import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'es6-promise/auto'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import { BModal } from 'bootstrap-vue'
import { BButton } from 'bootstrap-vue'
import { BTab } from 'bootstrap-vue'
import { BTabs } from 'bootstrap-vue'
import { BCard } from 'bootstrap-vue'
import { BCardText } from 'bootstrap-vue'
import { BTable } from 'bootstrap-vue'
import { BPagination } from 'bootstrap-vue'
import { BFormSelect } from 'bootstrap-vue'
import { BFormGroup } from 'bootstrap-vue'
import { BImg } from 'bootstrap-vue'
import { BAlert } from 'bootstrap-vue'
import { BButtonGroup } from 'bootstrap-vue'
import { ToastPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faGraduationCap, faHeadset, faLaptop, faLightbulb, faSchool, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleUp } from '@fortawesome/free-solid-svg-icons'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { faVolleyballBall } from '@fortawesome/free-solid-svg-icons'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import { faHourglass } from '@fortawesome/free-regular-svg-icons'
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faUndo } from '@fortawesome/free-solid-svg-icons'
import { faGavel } from '@fortawesome/free-solid-svg-icons'
import { faReply } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faUserLock } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faListAlt } from '@fortawesome/free-solid-svg-icons'
import { faWrench } from '@fortawesome/free-solid-svg-icons'
import { faHandPaper } from '@fortawesome/free-regular-svg-icons'
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons'
import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { faUserInjured } from '@fortawesome/free-solid-svg-icons'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faTv } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons'
import { faFileImport } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import utils from './utils'
import estados from './managers/estados'
import { io } from "socket.io-client";
import i18n from './plugins/i18n'
import './registerServiceWorker'
import PWAInstaller from './plugins/pwa-installer'

library.add(faSignOutAlt, faAddressCard, faArrowAltCircleUp, faPlayCircle, faVolleyballBall, 
            faHourglass, faSyncAlt, faExchangeAlt, faCog, faUndo, faGavel, faReply, faEdit, 
            faUser, faUsers, faArrowLeft, faTrashAlt, faUserLock, faInfoCircle, faListAlt, 
            faWrench, faHandPaper, faCaretLeft, faCaretRight, faUserInjured, faUpload, faDownload, 
            faTv, faCircle, faThumbsUp, faThumbsDown, faAngleDoubleDown, faAngleDoubleUp, faSlidersH, 
            faGraduationCap, faSchool, faLaptop, faLightbulb, faCheckCircle, faHeadset, faFileImport)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.use(PWAInstaller);

Vue.component('b-tab', BTab)
Vue.component('b-tabs', BTabs)
Vue.component('b-card', BCard)
Vue.component('b-card-text', BCardText)
Vue.component('b-modal', BModal)
Vue.component('b-button', BButton)
Vue.component('b-table', BTable)
Vue.component('b-pagination', BPagination)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-img', BImg)
Vue.component('b-alert', BAlert)
Vue.component('b-button-group', BButtonGroup)

// Global event bus
Vue.prototype.$eventHub = new Vue();

// Moment JS Global helper
Vue.prototype.moment = moment;
Vue.prototype.utils = utils;

let defaultMatchSettings = {
    pointsBySet: 25,
    tieBreakPoints: 15,
    timeoutDuration: 30,
    tiemposTecnicosPorSet: 2,
    cambiosPorSet: 6,
    cambiosPermitirAbiertos: false,
    cambiosPermitirReingresoCerrados: false,
    cambioDeLadoEntreSets: false,
    tipoEstadisticas: 'basic',
    obligatoryAllSets: false
}

new Vue({
    i18n,
    data: {
        
        config: {
            version: process.env.VUE_APP_VERSION,
            deviceId: null,
            deviceVerification: null,
            apiURL: process.env.VUE_APP_COURTRACK_API_HOST,
            dashHost: process.env.VUE_APP_DEFAULT_DASH_HOST,
            dashMode: process.env.VUE_APP_DEFAULT_DASH_MODE,
            dashPort: process.env.VUE_APP_DASH_API_PORT,
            cambiosPorSet: 6,
            cambiosPermitirAbiertos: false,
            cambiosPermitirReingresoCerrados: false,
            cambioDeLadoEntreSets: true,
            tipoEstadisticas: 'basic',
            maximoLiberos: 2,
            maximoJugadoresCancha: 16,        
        },

        configEstadisticas: [
            {
              "id": "puntoAtaque",
              "tipo": "punto",
              "descripcion_es": "Ataque",
              "descripcion_en": "Attack",
              "posiciones": "1,2,3,4,5,6,7",
              "acciones": []
            },
            {
              "id": "puntoBloqueo",
              "tipo": "punto",
              "descripcion_es": "Bloqueo",
              "descripcion_en": "Block",
              "posiciones": "2,3,4",
              "acciones": []
            },
            {
              "id": "puntoSaque",
              "tipo": "punto",
              "descripcion_es": "Ace",
              "descripcion_en": "Ace",
              "posiciones": "1",
              "acciones": []
            },
            {
              "id": "error",
              "tipo": "error",
              "descripcion_es": "Error No Forzado",
              "descripcion_en": "Unforced Error",
              "posiciones": "1,2,3,4,5,6,7",
              "acciones": []
            },
            {
              "id": "errorSaque",
              "tipo": "error",
              "descripcion_es": "Error Saque",
              "descripcion_en": "Service Error",
              "posiciones": "1",
              "acciones": []
            }
        ],

        clientes: [],

        socket:null,

        planilla: {
            equipoA: {id: null, jugadores: [], entrenador: null, asistente1: null, asistente2: null},
            equipoB: {id: null, jugadores: [], entrenador: null, asistente1: null, asistente2: null},
            puntos: [],
            eventos: [],
            planilla: { 
                sets: [] 
            },
            settings: defaultMatchSettings,
            estadisticas: [],
            undoList: [],
            undoEstadisticasList: [],
            acciones: [],
        },

        planillasToPersist: [],

        // Add new variables for debounce
        lastPersistTimestamp: 0,
        persistTimeout: null,
        isPersisting: false,

        DASH_ACTIONS: {
            nextMatch: 'nextMatch',
            presentation: 'presentation',
            warmup: 'warmup',
            scoreboard: 'scoreboard',
            continue: 'continue',
            timeout: 'timeout',
            substitution: 'substitution',
            sanction: 'sanction',
            endSet: 'endSet',
            endMatch: 'endMatch',
            mvp: 'mvp',
            watch: 'watch',
            team: 'team',
            switchSides: 'switchSides'
        },
        
        startSetTeamASide: '', 
        startSetTeamBSide: '', 
        startSetTeamService: '', 
        startSetRotationAIds: '', 
        startSetRotationBIds: '',

        dashLastAction: '',
        dashReverseLado: false,

        prevEstado: '',

        dashOnline: null,
        forceOffline: false,
        checkOnlineInterval: null
    },

    computed: {
        currentUser() {
            return this.$store.getters['auth/currentUser'];
        },

        currentPuntoIndex: function() {
            return this.planilla.puntos.length ? this.planilla.puntos.length-1 : 0;
        },

        currentPunto: function() {
            return this.planilla.puntos.length ? this.planilla.puntos[this.currentPuntoIndex] : {};
        },

        prevPunto: function() {
            return this.planilla.puntos.length > 1 ? this.planilla.puntos[this.currentPuntoIndex - 1] : {};
        },

        currentLadoA: function() {
            return this.currentPunto.ladoA || 'I';
        },

        currentLadoB: function() {
            return this.currentPunto.ladoB || 'D';
        },

        currentSet: function() {
            return this.currentPunto.id_set;
        },

        nextSetOrder: function() {
            let order = ['er', 'do', 'er', 'to', 'to'];
            let nro = isNaN(this.currentPunto.id_set) ? 0 : this.currentPunto.id_set+1;
            return (nro+1) + order[nro];
        },

        currentEstado: function() {
            return this.planilla.estado;
        },

        isPlaying: function() {
            return estados.isPlaying(this.planilla.estado);
        },

        canStartSet: function() {
            return estados.canStartSet(this.planilla.estado);
        },

        equipoA: function() {
            return this.planilla.equipoA.id;
        },

        equipoB: function() {
            return this.planilla.equipoB.id;
        },

        jugadoresA: function() {
            return this.planilla.equipoA.jugadores;
        },

        jugadoresB: function() {
            return this.planilla.equipoB.jugadores;
        },

        jugadoresOptions: function() {
            return ([{value: null, text: '-'}]).concat(this.planilla.equipoA.jugadores.concat(this.planilla.equipoB.jugadores)
                .filter(jugador => jugador.numero)
                .map(jugador =>
                    {
                        let aiscore = (this.planilla.AIScore && Array.isArray(this.planilla.AIScore)) 
                            ? this.planilla.AIScore.find(aiscore => aiscore.id == jugador.id) 
                            : null;
                        if (jugador.numero) return {value: jugador.id, text: `${jugador.apellido}, ${jugador.nombre} #${jugador.numero} - ${jugador.equipo} - AIS: ${aiscore ? aiscore.total : ''}`}
                    }
                )
            )
        },

        currentScoreA: function() {
            return this.currentPunto.tanteadorA;
        },

        currentScoreB: function() {
            return this.currentPunto.tanteadorB;
        },

        currentEquipoABD: function() {
            return this.currentLadoA == 'D' ? 'A' : 'B';
        },

        currentEquipoABI: function() {
            return this.currentLadoA == 'I' ? 'A' : 'B';
        },

        isMatchPoint: function() {

            let ret = false;
            if (this.planilla.settings.obligatoryAllSets) {
                // En formato de sets obligatorios, match point solo en el último set (no es tiebreak, es a 25)
                const isLastSet = this.currentPunto.id_set + 1 == this.planilla.settings.numberOfSets;
                if (isLastSet && this.isSetPoint) {
                    ret = true;
                }
            } else {
                let setsAGanar = Math.ceil(this.planilla.settings.numberOfSets / 2);
                if ((this.getSetsAB('A') == setsAGanar-1 && this.currentPunto.tanteadorA > this.currentPunto.tanteadorB && this.isSetPoint) ||
                    (this.getSetsAB('B') == setsAGanar-1 && this.currentPunto.tanteadorB > this.currentPunto.tanteadorA && this.isSetPoint)) {
                    ret = true;
                }
            }
            return ret;
        },

        isSetPoint: function() {
            let ret = false;
            let point = this.currentPunto;

            if ((!this.isSetTieBreak(point.id_set) && ((point.tanteadorA >= this.planilla.settings.pointsBySet - 1 && point.tanteadorA > point.tanteadorB) ||
                                         (point.tanteadorB >= this.planilla.settings.pointsBySet - 1 && point.tanteadorB > point.tanteadorA))) ||
                ( this.isSetTieBreak(point.id_set) && ((point.tanteadorA >= this.planilla.settings.tieBreakPoints - 1 && point.tanteadorA > point.tanteadorB) ||
                                         (point.tanteadorB >= this.planilla.settings.tieBreakPoints - 1 && point.tanteadorB > point.tanteadorA)))) {
                ret = true;
            }
            return ret;
        },

        sets_a: function() {
            let sets = 0;
            for (let i=0;i<this.planilla.settings.numberOfSets; i++) {
                const points = this.planilla.puntos.filter(punto => {return punto.id_set == i});
                const lastPoint = points[points.length-1];
                if (lastPoint) {
                    if ((lastPoint.tanteadorA >= this.planilla.settings.pointsBySet && lastPoint.tanteadorB < lastPoint.tanteadorA - 1) ||
                        (this.isSetTieBreak(lastPoint.id_set) && lastPoint.tanteadorA >= this.planilla.settings.tieBreakPoints && lastPoint.tanteadorB < lastPoint.tanteadorA - 1)) {
                        sets++;
                    }
                }
            }
            return sets;
        },

        sets_b: function() {
            let sets = 0;
            for (let i=0;i<this.planilla.settings.numberOfSets; i++) {
                const points = this.planilla.puntos.filter(punto => {return punto.id_set == i});
                const lastPoint = points[points.length-1];
                if (lastPoint) {
                    if ((lastPoint.tanteadorB >= this.planilla.settings.pointsBySet && lastPoint.tanteadorA < lastPoint.tanteadorB - 1) ||
                        (this.isSetTieBreak(lastPoint.id_set) && lastPoint.tanteadorB >= this.planilla.settings.tieBreakPoints && lastPoint.tanteadorA < lastPoint.tanteadorB - 1)) {
                        sets++;
                    }
                }
            }
            return sets;
        },

        acciones: function() {

            // join puntos y eventos arrays
            let events = this.planilla.puntos.concat(this.planilla.eventos);

            events.sort((a,b) => a.inicio - b.inicio);

            let idx = 1;

            return events.flatMap((event) => {

                let eventType = '';
                let eventTypeDesc = '';
                let eventDescription = '';
                let items = [];

                // inicioPartido
                if (event.rotacionA && event.id_punto == 0) {
                    eventType = 'Inicio Partido';
                    eventTypeDesc = i18n.t('match-start');
                    eventDescription = `${i18n.t('match-started-at')} ${this.utils.formatTime(event.inicio)}`;
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: 0,
                        tanteadorB: 0
                    })    
                    idx++;
                }

                // inicioSet
                if (event.rotacionA && event.tanteadorA === 0 && event.tanteadorB === 0) {
                    eventType = 'Inicio Set';
                    eventTypeDesc = i18n.t('set-start');
                    eventDescription = `${i18n.t('set')} ${event.id_set + 1} ${i18n.t('started-at')} ${this.utils.formatTime(event.inicio)}`;
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: 0,
                        tanteadorB: 0
                    })
                    idx++;
                }

                // punto
                if (!eventType && event.rotacionA && (event.tanteadorA > 0 || event.tanteadorB > 0)) {
                    eventType = 'Punto';
                    eventTypeDesc = i18n.t('point');
                    eventDescription = `${(event.servicio == 'A' ? this.equipoA : this.equipoB)}`;
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: event.tanteadorA,
                        tanteadorB: event.tanteadorB
                    })    
                    idx++;
                }

                // cambio
                if (event.tipo && event.tipo == 'cambio') {
                    eventType = 'Cambio';
                    eventTypeDesc = i18n.t('substitution');
                    let jugador = this.getJugadorById(event.id_persona);
                    let jugadorOut = this.getJugadorById(event.id_persona_out);
                    let punto = this.planilla.puntos[event.id_punto];
                    eventDescription = `${event.id_equipo}. ${i18n.t('player-in')} #${event.numero} (${jugador.apellido}, ${jugador.nombre}). ${i18n.t('player-out')} #${event.numero_out} (${jugadorOut.apellido}, ${jugadorOut.nombre}).`;
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: punto.tanteadorA,
                        tanteadorB: punto.tanteadorB
                    })
                    idx++;
                }

                // tiempo
                if (event.tipo && event.tipo == 'tiempo') {
                    eventType = "Tiempo Tecnico";
                    eventTypeDesc = i18n.t('timeout');
                    eventDescription = `${i18n.t('requested-by')} ${event.id_equipo}`;
                    let punto = this.planilla.puntos[event.id_punto];
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: punto.tanteadorA,
                        tanteadorB: punto.tanteadorB
                    })
                    idx++;
                }

                // sancion
                if (event.tipo && event.tipo.includes('sanction')) {
                    eventType = "Sancion";
                    eventTypeDesc = i18n.t('sanction');
                    const sanctionTypes = {
                        warning: i18n.t('warning'), 
                        penalty: i18n.t('penalty'), 
                        expulsion: i18n.t('expulsion'), 
                        disqualification: i18n.t('disqualification'),
                        green: i18n.t('green'),
                        delay: i18n.t('delay'),
                        delayPenalty: i18n.t('delay-penalty')
                    }
                    let jugador = this.getJugadorById(event.id_persona);
                    if (jugador) {
                        eventDescription = `${event.id_equipo} - ${sanctionTypes[event.tipo.split(':')[1]]} Nro ${event.numero} (${jugador.apellido}, ${jugador.nombre}).`;
                    } else {
                        eventDescription = `${event.id_equipo} - ${sanctionTypes[event.tipo.split(':')[1]]}`;
                    }
                    let punto = this.planilla.puntos[event.id_punto];
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: punto.tanteadorA,
                        tanteadorB: punto.tanteadorB
                    })
                    idx++;
                }

                // finSet
                if (event.rotacionA && Math.abs(event.tanteadorA - event.tanteadorB) >= 2 && (event.tanteadorA >= this.planilla.settings.pointsBySet || event.tanteadorB >= this.planilla.settings.pointsBySet)) {
                    eventType = 'Fin Set';
                    eventTypeDesc = i18n.t('end-set');
                    eventDescription = `${i18n.t('set')} ${event.id_set+1} ${i18n.t('ended-at')} ${this.utils.formatTime(event.inicio)}`;
                    items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: event.tanteadorA,
                        tanteadorB: event.tanteadorB
                    })
                    idx++;
                }

                // finSet (tie-break)
                if (event.rotacionA && 
                    Math.abs(event.tanteadorA - event.tanteadorB) >= 2 && 
                    this.planilla.settings.numberOfSets == event.id_set+1 &&
                    (event.tanteadorA >= this.planilla.settings.tieBreakPoints || event.tanteadorB >= this.planilla.settings.tieBreakPoints)) {
                    eventType = 'Fin Set';
                    eventTypeDesc = i18n.t('end-set');
                    eventDescription = `${i18n.t('set')} ${event.id_set+1} ${i18n.t('ended-at')} ${this.utils.formatTime(event.inicio)}`;
                        items.push({
                        id: idx,
                        id_punto: event.id_punto,
                        id_set: event.id_set,
                        hora: this.utils.formatTime(event.inicio),
                        inicio: event.inicio,
                        fin: event.fin,
                        tipo: eventType,
                        tipoDesc: eventTypeDesc,
                        descripcion: eventDescription,
                        tanteadorA: event.tanteadorA,
                        tanteadorB: event.tanteadorB
                    })
                    idx++;
                }

                return items;
            }).sort((a,b) => b.id - a.id);
        },
    },

    async mounted() {
        // Initialize auth state from localStorage
        await this.$store.dispatch('auth/initializeAuth');
        
        this.$eventHub.$on('action', this.actionHandler);
        this.$eventHub.$on('persist', this.persistHandler);

        store.dispatch('partidos/retrieveFromLS');
        store.dispatch('equipos/retrieveFromLS');
        store.dispatch('personas/retrieveFromLS');
        store.dispatch('planillas/retrieveFromLS');
        store.dispatch('estadisticas/retrieveFromLS');

        // patch for version migration (if no config present)
        let configEstadisticas = this.$store.getters['estadisticas/getConfig'];
        if (!configEstadisticas || !configEstadisticas.length) {
            this.downloadEstadisticas();
        }

        // get device unique id
        this.config.deviceId = this.getDeviceUniqueId();

        this.readConfiguration();

        this.getClientes();

        // set configured lang
        if (this.config.language) {
            this.$store.dispatch('localization/changeLocale', this.config.language);
        } else {
            const lang = navigator.language.split("-")[0];
            this.$store.dispatch('localization/changeLocale', lang);
            this.$root.config.language = lang;
            this.$root.saveConfiguration();
        }

        this.connectSocket();

        this.checkLatestVersion();

        clearInterval(this.checkOnlineInterval);
        this.checkOnlineInterval = setInterval(this.pingServers, 10000);
    },

    methods: {

        async checkLatestVersion() {
            let currentVersion = this.config.version;
            let latestVersion = null;
            let url = encodeURI(this.$root.config.apiURL + '/api/ruler/getCurrentVersion');
            let response = await this.axios.get(url);
            if (!response.error && response.data) {
                latestVersion = response.data.data;
            }

            if (currentVersion != latestVersion) {

                this.$bvModal.msgBoxConfirm(i18n.t('new-version-detected'), {
                    title: i18n.t('update-version'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('yes'),
                    cancelTitle: i18n.t('no'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async (value) => {
                    if (value) {                
                        this.refreshVersion();
                    }
                })
            }
        },

        async getClientes() {
            let url = encodeURI(this.$root.config.apiURL + '/api/torneo/getAllClientes');
            let response = await this.axios.get(url);
            if (!response.error && response.data) {
                this.$store.dispatch('auth/setClientes', response.data);
            }
        },

        refreshVersion() {
            let url = location.protocol + '//' + location.host + location.pathname;
            window.location.href = `${url}?cache=${new Date().getTime()}`;
        },

        getDeviceUniqueId() {
            let deviceId = localStorage.getItem('courtrack_device_id');
            if (!deviceId) {
                deviceId = (crypto && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                localStorage.setItem('courtrack_device_id', deviceId);
            }
            return deviceId;
        },

        applyClientConfig(config) {
            if (!config) return;
            if (config.maxPlayers > 0) this.config.maximoJugadoresCancha = config.maxPlayers;
            if (config.maxLiberos > 0) this.config.maximoLiberos = config.maxLiberos;
            if (config.mvpEditEnabled !== undefined) this.config.mvpEditEnabled = config.mvpEditEnabled === 1;
        },

        async reloadNominas() {

            // reload nominas from server
            let url = encodeURI(`${this.config.apiURL}/api/ruler/downloadClientData/${this.currentUser.id_cliente}`);
            let response = await this.axios.get(url);
            this.applyClientConfig(response.data.data.config);
            await this.$store.dispatch('personas/setAndPersistLS', response.data.data.personas);
            
            // Update players for both teams
            [this.$root.planilla.equipoA, this.$root.planilla.equipoB].forEach(equipo => {
                const jugadores = this.$store.getters['personas/getPersonasByEquipoTorneo'](equipo.id, this.$root.planilla.id_torneo);
                jugadores.forEach(jugador => {
                    const jugadorPlanilla = equipo.jugadores.find(item => item.id === jugador.id && item.tipo === jugador.tipo);
                    if (!jugadorPlanilla) {
                        equipo.jugadores.push(this.utils.adaptJugador(jugador));
                    } else {
                        const preservar = ['numero', 'rol'];
                        Object.keys(jugador).forEach(prop => {
                            if (jugador.hasOwnProperty(prop) && !preservar.includes(prop)) {
                                jugadorPlanilla[prop] = jugador[prop];
                            }
                        })
                    }
                })
            })
        },

        connectSocket() {

            if (this.config.dashMode != 'ws' && this.config.dashMode != 'wss') return;

            if (this.socket) this.socket.close();

            this.socket = io(this.getDashWSURL());

            this.socket.on("connect", () => {

                this.dashOnline = true;

                this.socket.on("action-all", (data) => {
                    this.dashOnline = true;
                    this.onSocketDataReceived(data);
                })

                this.socket.on("acreditaciones:make", (data) => {

                    // chequea que el mensaje es para acreditar en este partido
                    if (data.id_partido != this.planilla.id_partido ||
                        data.id_cliente != this.planilla.id_cliente) {
                        return;
                    }

                    const teamAB = data.equipo == this.planilla.equipoA.id ? 'A' : 'B';

                    // valida si esta usada el nro de camiseta
                    const jugadorMismoNumero = this.planilla['equipo' + teamAB].jugadores.find(jugador => jugador.numero == data.numero);
                    if (jugadorMismoNumero) {
                        if (jugadorMismoNumero.id == data.id_persona) {
                            return this.socket.emit("acreditaciones:result", {
                                hash: data.hash,
                                success: true,
                                message: 'El jugador ya se encuentra acreditado'
                            })
                        } else {
                            return this.socket.emit("acreditaciones:result", {
                                hash: data.hash,
                                success: false,
                                message: 'La camiseta seleccionada ya esta siendo utilizada por otro jugador'
                            })
                        }
                    }

                    // si ya hay un capitan muestra error
                    if (data.roles.includes('capitan')) {
                        const existingCapitan = this.planilla['equipo' + teamAB].jugadores.find(jugador => jugador.rol.includes('capitan'));
                        if (existingCapitan && existingCapitan.id != data.id_persona) {
                            return this.socket.emit("acreditaciones:result", {
                                hash: data.hash,
                                success: false,
                                message: 'Ya hay un capitan designado para el equipo.'
                            })
                        }
                    }                

                    // si ya hay la cantidad de liberos permitidos
                    if (data.roles.includes('libero')) {
                        const liberos = this.planilla['equipo' + teamAB].jugadores.filter(jugador => jugador.rol.includes('libero'));
                        if (liberos.length >= this.config.maximoLiberos) {
                            return this.socket.emit("acreditaciones:result", {
                                hash: data.hash,
                                success: false,
                                message: 'El equipo ya tiene designados la maxima cantidad de liberos permitidos.'
                            })
                        }
                    }

                    // si ya hay la cantidad de jugadores de cancha permitidos
                    if (!data.roles.includes('libero')) {
                        const jugadores = this.planilla['equipo' + teamAB].jugadores.filter(jugador => 
                            !jugador.rol.includes('libero') && 
                            jugador.numero &&
                            jugador.id != data.id_persona);
                        if (jugadores.length >= this.config.maximoJugadoresCancha) {
                            return this.socket.emit("acreditaciones:result", {
                                hash: data.hash,
                                success: false,
                                message: 'El equipo ya tiene designados la maxima cantidad de jugadores de cancha permitidos.'
                            })
                        }
                    }

                    // si todo esta ok acredita el jugador
                    let jugador = this.planilla['equipo' + teamAB].jugadores.find(jugador => jugador.id == data.id_persona && jugador.tipo == 'jugador');
                    jugador.numero = data.numero;
                    jugador.rol = data.roles;                    
                    this.$forceUpdate();
                    this.$eventHub.$emit('playersUpdated');                        
                    
                    // muestra mensaje de confirmacion
                    this.$root.showInfo(
                        i18n.t('accreditations'), 
                        `${data.equipo}: ${jugador.apellido.toUpperCase()} - ${data.numero} ${i18n.t('accredit')}!` + 
                        (data.roles.includes('capitan') ? ` (${i18n.t('captain')})` : '') + 
                        (data.roles.includes('libero') ? ` (${i18n.t('libero')})` : ''));

                    return this.socket.emit("acreditaciones:result", {
                        hash: data.hash,
                        success: true
                    })
                })
            })
            this.socket.on("connect_error", () => {
                this.dashOnline = false;
            })
        },

        async pingServers() {
            this.dashOnline = await this.isDashOnline();

            // when connection is recovered save pending scoresheets
            if (this.dashOnline && this.planillasToPersist.length && !this.isPersisting) {
                this.persistPlanillas();
            }
        },

        createNewPlanilla() {

            // override default match settings with stored settings
            defaultMatchSettings.cambioDeLadoEntreSets = this.config.cambioDeLadoEntreSets;
            defaultMatchSettings.tipoEstadisticas = this.config.tipoEstadisticas;
            defaultMatchSettings.cambiosPorSet = this.config.cambiosPorSet;
            defaultMatchSettings.cambiosPermitirAbiertos = this.config.cambiosPermitirAbiertos;
            defaultMatchSettings.cambiosPermitirReingresoCerrados = this.config.cambiosPermitirReingresoCerrados;
            
            this.planilla = {
                id_partido: undefined,
                estado: 'inicioPartido',
                updated: null,
                equipoA: {id: null, jugadores: [], entrenador: null, asistente1: null, asistente2: null},
                equipoB: {id: null, jugadores: [], entrenador: null, asistente1: null, asistente2: null},
                puntos: [],
                eventos: [],
                planilla: { 
                    sets: [] 
                },
                settings: defaultMatchSettings
            }
        },

        savePlanilla() {

            // set last update time
            this.planilla.updated = Date.now();

            // save event list and app mode
            this.planilla.acciones = this.acciones;

            // store sheet
            this.$store.dispatch('planillas/updateOrInsert', utils.copy(this.planilla));
        },

        showWarning: function(title, content) {
            this.showToast('warning', title, content);
        },

        showError: function(title, content) {
            this.showToast('danger', title, content);
        },

        showInfo: function(title, content) {
            this.showToast('success', title, content);
        },

        showToast: function(variant, title, content) {

            this.$bvToast.toast(content, {
                title: title,
                variant: variant,
                autoHideDelay: 8000
            })
    
            let audio = new Audio(require('./assets/sound/bigbox.mp3'));
            audio.play();
        },

        isSetEnded: function(set) {

            if (set > this.currentSet) return false;
            if (set < this.currentSet) return true;

            let point = this.getSetLastPoint(set);
            
            // evaluates if this is the set end
            if ((point.tanteadorA >= this.planilla.settings.pointsBySet && point.tanteadorB < point.tanteadorA-1) ||
                (point.tanteadorB >= this.planilla.settings.pointsBySet && point.tanteadorA < point.tanteadorB-1) ||
                (this.isSetTieBreak(set) && point.tanteadorA >= this.planilla.settings.tieBreakPoints && point.tanteadorB < point.tanteadorA-1) ||
                (this.isSetTieBreak(set) && point.tanteadorB >= this.planilla.settings.tieBreakPoints && point.tanteadorA < point.tanteadorB-1)) {
                return true;
            } else {
                return false;
            }
        },

        isSetTieBreak: function(set) {
            if (this.planilla.settings.obligatoryAllSets) return false;
            return set+1 == this.planilla.settings.numberOfSets;
        },

        hasCambiosDisponiblesBySide: function (side) {
            let substitutes = this.getSubstitutes(side, false);
            let cambios = this.getCambiosBySideSet(side, this.currentSet);
            return substitutes.length && cambios.length < this.planilla.settings.cambiosPorSet;
        },

        getCapitan: function(teamAB) {
            let capitan = this['jugadores' + teamAB].find(jugador => jugador.rol && jugador.rol.includes('capitan'));
            return capitan;
        },

        getSetsAB: function(teamAB) {
            let sets = 0;
            let teamBA = teamAB == 'A' ? 'B' : 'A';
            for (let i=0;i<this.planilla.settings.numberOfSets; i++) {
                const points = this.planilla.puntos.filter(punto => {return punto.id_set == i});
                const lastPoint = points[points.length-1];
                if (lastPoint) {
                    if ((lastPoint['tanteador' + teamAB] >= this.planilla.settings.pointsBySet && lastPoint['tanteador' + teamBA] < lastPoint['tanteador' + teamAB] - 1) ||
                        (this.isSetTieBreak(lastPoint.id_set) && lastPoint['tanteador' + teamAB] >= this.planilla.settings.tieBreakPoints && lastPoint['tanteador' + teamBA] < lastPoint['tanteador' + teamAB] - 1)) {
                        sets++;
                    }
                }
            }
            return sets;
        },

        getCambiosByTeamABSet: function(teamAB, set) {
            let cambios = this.planilla.eventos.filter(evento => evento.id_set == set && evento.id_equipo == this.getTeamIdByAB(teamAB) && evento.tipo == 'cambio');
            return cambios.map(cambio => {
                if (teamAB == 'A') {
                    return `${this.planilla.puntos[cambio.id_punto].tanteadorA} : ${this.planilla.puntos[cambio.id_punto].tanteadorB}`;
                } else {
                    return `${this.planilla.puntos[cambio.id_punto].tanteadorB} : ${this.planilla.puntos[cambio.id_punto].tanteadorA}`;
                } 
            }) || [];
        },

        getCambiosBySideSet: function(side, set) {
            let cambios = this.planilla.eventos.filter(evento => (set==undefined || evento.id_set == set) && evento.id_equipo == this.getTeamIdBySide(side) && evento.tipo == 'cambio');
            return cambios && cambios.length ? cambios : [];
        },

        getCambiosAbiertosBySideSet: function(side, set) {
            let cambios = JSON.parse(JSON.stringify(this.planilla.eventos.filter(evento => (set==undefined || evento.id_set == set) && evento.id_equipo == this.getTeamIdBySide(side) && evento.tipo == 'cambio')));

            for(let i=0;i<cambios.length;i++) {
                for(let j=i+1;j<cambios.length;j++) {
                    if (cambios[i].numero == cambios[j].numero_out && cambios[i].numero_out == cambios[j].numero) {
                        cambios[i].cerrado = true;
                        cambios[j].cerrado = true;
                    }
                }
            }

            let cambiosAbiertos = cambios.filter(cambio => !cambio.cerrado);

            return cambiosAbiertos && cambiosAbiertos.length ? cambiosAbiertos : [];
        },

        getCambiosFormacionByTeamABSet: function(teamAB, set) {
            let punto = this.getSetInitialPoint(set);
            let formacion = teamAB == 'A' ? punto.rotacionA : punto.rotacionB;
            let equipo = teamAB == 'A' ? this.equipoA : this.equipoB;
            let cambios = this.planilla.eventos.filter(evento => evento.id_set == set && evento.id_equipo == equipo && evento.tipo == 'cambio');

            return formacion.map(id => {
                let cambio = cambios.find(cambio => cambio.id_persona_out == id);
                return cambio ? cambio.numero : '';
            })
        },

        getCambiosFormacionTanteadorByTeamABSet: function(teamAB, set) {
            let punto = this.getSetInitialPoint(set);
            let formacion = teamAB == 'A' ? punto.rotacionA : punto.rotacionB;
            let equipo = teamAB == 'A' ? this.equipoA : this.equipoB;
            let cambios = this.planilla.eventos.filter(evento => evento.id_set == set && evento.id_equipo == equipo && evento.tipo == 'cambio');

            return formacion.map(id => {
                let cambio = cambios.find(cambio => cambio.id_persona_out == id);
                if (cambio) {
                    if (teamAB == 'A') return this.planilla.puntos[cambio.id_punto].tanteadorA + ':' + this.planilla.puntos[cambio.id_punto].tanteadorB;
                    if (teamAB == 'B') return this.planilla.puntos[cambio.id_punto].tanteadorB + ':' + this.planilla.puntos[cambio.id_punto].tanteadorA;
                }
                return ':';
            })
        },

        getCambiosFormacionCerradosTanteadorByTeamABSet: function(teamAB, set) {
            let punto = this.getSetInitialPoint(set);
            let formacion = teamAB == 'A' ? punto.rotacionA : punto.rotacionB;
            let equipo = teamAB == 'A' ? this.equipoA : this.equipoB;
            let cambios = this.planilla.eventos.filter(evento => evento.id_set == set && evento.id_equipo == equipo && evento.tipo == 'cambio');

            return formacion.map(id => {
                let cambio = cambios.find(cambio => cambio.id_persona == id);
                if (cambio) {
                    if (teamAB == 'A') return this.planilla.puntos[cambio.id_punto].tanteadorA + ':' + this.planilla.puntos[cambio.id_punto].tanteadorB;
                    if (teamAB == 'B') return this.planilla.puntos[cambio.id_punto].tanteadorB + ':' + this.planilla.puntos[cambio.id_punto].tanteadorA;
                }
                return ':';
            })
        },

        getCambiosFormacionCerradosByTeamABSet: function(teamAB, set) {
            let punto = this.getSetInitialPoint(set);
            let formacion = teamAB == 'A' ? punto.rotacionA : punto.rotacionB;
            let equipo = teamAB == 'A' ? this.equipoA : this.equipoB;
            let cambios = this.planilla.eventos.filter(evento => evento.id_set == set && evento.id_equipo == equipo && evento.tipo == 'cambio');

            return formacion.map(id => {
                let cambio = cambios.find(cambio => cambio.id_persona == id);
                return !!cambio;
            })
        },

        hasTiemposDisponiblesBySide: function (side) {
            return this.getTiemposBySideSet(side, this.currentSet).length < this.planilla.settings.tiemposTecnicosPorSet;
        },

        getTiemposBySideSet: function(side, set) {
            return this.getTiemposByTeamABSet(this.currentLadoA == side ? 'A' : 'B', set);
        },

        getStarter: function(side, pos) {

            let rotacion = this.getCurrentRotationBySide(side);

            if (!rotacion) return;

            let playerId = rotacion[pos-1];
            let jugadores = [];
            let ret = null;

            if (this.currentLadoA == side) {
                jugadores = this.planilla.equipoA.jugadores;
            }

            if (this.currentLadoB == side) {
                jugadores = this.planilla.equipoB.jugadores;
            }

            jugadores.map(jugador => {
                if (jugador.id == playerId && jugador.tipo == 'jugador' && jugador.numero) {
                    ret = jugador;
                }
            })

            return ret;
        },

        getSetStarter: function(side, pos) {

            let punto = this.getSetInitialPoint(this.currentSet);
            let rotacion = punto.ladoA == side ? punto.rotacionA : punto.rotacionB;

            if (!rotacion) return;

            let playerId = rotacion[pos-1];
            let jugadores = [];
            let ret = null;

            if (this.currentLadoA == side) {
                jugadores = this.planilla.equipoA.jugadores;
            }

            if (this.currentLadoB == side) {
                jugadores = this.planilla.equipoB.jugadores;
            }


            jugadores.map(jugador => {
                if (jugador.id == playerId && jugador.tipo == 'jugador' && jugador.numero && !jugador.rol.includes('libero')) {
                    ret = jugador;
                }
            })

            return ret;
        },

        getJugadorByNumeroSide: function(numero, side) {
            let jugadores = (this.currentLadoA == side) ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;
            return jugadores.find(jugador => jugador.numero == numero)
        },

        getJugadorById: function(id) {
            let jugadores = this.planilla.equipoA.jugadores.concat(this.planilla.equipoB.jugadores);
            return jugadores.find(jugador => jugador.id == id)
        },

        getJugadorSancion: function(side, numero) {

          let ret = '';

          if (!side || !numero) return ret;

          let jugadores = (this.currentLadoA == side) ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;
          let jugador = jugadores.find(jugador => jugador.numero == numero);

          if (!jugador) return ret;

          this.planilla.eventos.map(evento => {

            if (evento.tipo.includes('sanction') && evento.id_persona == jugador.id) {
              if (evento.tipo == 'sanction:disqualification') ret = 'disqualification';
              if (evento.tipo == 'sanction:expulsion' && evento.id_set == this.currentSet) ret = 'expulsion'
            }
          })

          return ret;
        },

        getAcreditados: function(teamAB) {
            let jugadores = teamAB == 'A' ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;
            return jugadores.filter(jugador => jugador.numero)
                .sort((a, b) => a.numero - b.numero);
        },

        getStarterId: function(side, pos) {
            let player = this.getStarter(side, pos);
            return player ? Number(player.id) : null;
        },

        getStarterRol: function(side, pos) {
            let player = this.getStarter(side, pos);
            return player ? player.rol : [];
        },

        getStarterNumber: function(side, pos) {
            let player = this.getStarter(side, pos);
            return player ? player.numero : null;
        },

        getLiberos: function(side) {
            let jugadores = this.currentLadoA == side ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;
            return jugadores.filter(jugador => jugador.numero && jugador.rol.includes('libero'));
        },

        getSubstitutes: function(side, liberos=true) {
            let rotacion = this.getCurrentRotationBySide(side);
            
            if (!rotacion || !rotacion.length) return [];

            let jugadores = this.currentLadoA == side ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;

            let substitutes = jugadores.filter(jugador => jugador.numero && rotacion.indexOf(jugador.id) == -1 && (liberos || !jugador.rol.includes('libero')))
                .sort((a, b) => a.numero - b.numero);

            return substitutes && substitutes.length ? substitutes : [];
        },

        getSubstitutesNumeros: function(side, liberos=true) {
            let suplentes = this.getSubstitutes(side, liberos) || [];
            return suplentes.map(suplente => suplente.numero);
        },

        getSubstitute: function(side, index) {
            let suplentes = this.getSubstitutes(side);
            return suplentes ? suplentes[index-1] : null;
        },

        getSubstituteId: function(side, index) {
            let player = this.getSubstitute(side, index);
            return player ? Number(player.id) : null;
        },

        getSubstituteRol: function(side, index) {
            let player = this.getSubstitute(side, index);
            return player ? player.rol : [];
        },

        getSubstituteNumber: function(side, index) {
            let player = this.getSubstitute(side, index);
            return player ? player.numero : null;
        },

        getTiemposByTeamABSet: function(teamAB, set) {
            let tiempos = this.planilla.eventos.filter(evento => (set == undefined || evento.id_set == set) && evento.id_equipo == this.getTeamIdByAB(teamAB) && evento.tipo == 'tiempo');
            return tiempos.map(tiempo => {
                if (teamAB == 'A') {
                    return `${this.planilla.puntos[tiempo.id_punto].tanteadorA} : ${this.planilla.puntos[tiempo.id_punto].tanteadorB}`;
                } else {
                    return `${this.planilla.puntos[tiempo.id_punto].tanteadorB} : ${this.planilla.puntos[tiempo.id_punto].tanteadorA}`;
                } 
            }) || [];
        },

        getSetInitialPoint: function(set) {
            let puntos = this.getPuntosBySet(set);
            return puntos && puntos.length ? puntos[0] : {};
        },

        getSetLastPoint: function(set) {
            let puntos = this.utils.copy(this.getPuntosBySet(set));
            return puntos && puntos.length ? puntos.pop() : {};
        },

        getCurrentScoreBySetSide: function(side, set) {
            let puntos = this.getPuntosBySet(set);
            if (puntos && puntos.length) {
                if (this.currentLadoA == side) return puntos[puntos.length-1].tanteadorA;
                if (this.currentLadoB == side) return puntos[puntos.length-1].tanteadorB;
            }
            return null;
        },

        getCurrentScoreBySide: function(side) {
            if (this.currentLadoA == side) return this.currentPunto.tanteadorA || 0;
            if (this.currentLadoB == side) return this.currentPunto.tanteadorB || 0;
            return 0;
        },

        getTotalScoreBySide: function(side) {
            let total = 0;
            for(let i=0;i<this.planilla.settings.numberOfSets;i++) {
                let lastPoint = this.getLastPointBySet(i);
                if (this.currentLadoA == side) {
                    total += lastPoint ? lastPoint.tanteadorA : 0;
                } else {
                    total += lastPoint ? lastPoint.tanteadorB : 0;
                }
            }
            return total;
        },

        getCurrentSetsBySide: function(side) {
            if (this.currentLadoA == side) return this.planilla.sets_a || 0;
            if (this.currentLadoB == side) return this.planilla.sets_b || 0;
        },

        getTeamIdBySide: function(side) {
            if (this.currentLadoA == side) return this.planilla.equipoA.id;
            if (this.currentLadoB == side) return this.planilla.equipoB.id;
            if (!this.currentLadoA && side == 'I' && this.planilla.equipoA) return this.planilla.equipoA.id;
            if (!this.currentLadoA && side == 'D' && this.planilla.equipoB) return this.planilla.equipoB.id;
            return '&nbsp;';
        },

        getTeamIdBySetSide: function(set, side) {
            let punto = this.getSetInitialPoint(set);
            if (punto.ladoA == side) return this.planilla.equipoA.id;
            if (punto.ladoB == side) return this.planilla.equipoB.id;
            if (!punto.ladoA && side == 'I' && this.planilla.equipoA) return this.planilla.equipoA.id;
            if (!punto.ladoB && side == 'D' && this.planilla.equipoB) return this.planilla.equipoB.id;
        },

        getTeamIdByAB: function(teamAB) {
            return teamAB == 'A' ? this.equipoA : this.equipoB;
        },

        getCurrentRotationBySide: function(side) {
            if (this.currentPunto.ladoA == side) return this.currentPunto.rotacionA;
            if (this.currentPunto.ladoB == side) return this.currentPunto.rotacionB;
            return [];
        },

        getCurrentRotationNumerosBySide: function(side) {
            if (this.currentPunto.ladoA == side) return this.getRotacionNumeros(this.currentPunto.rotacionA, 'A');
            if (this.currentPunto.ladoB == side) return this.getRotacionNumeros(this.currentPunto.rotacionB, 'B');
            return [];
        },

        getPuntosBySet: function(set) {
            return this.planilla.puntos.filter(punto => {return punto.id_set == set});
        },

        getLastPointBySet: function(set) {
            return this.planilla.puntos.filter(punto => {return punto.id_set == set}).slice(-1).pop();
        },

        getSanctions: function() {
            return this.planilla.eventos.filter(evento => evento.tipo.substring(0,8) == "sanction").map(evento =>{
              return {
                id_set: evento.id_set, 
                id_punto: evento.id_punto, 
                id_equipo: evento.id_equipo, 
                id_persona: evento.id_persona,
                numero: evento.numero,
                tipo: evento.tipo.substring(9),
                inicio: evento.inicio,
              }
            })
        },

        getTantosSet(teamAB, set) {
            let punto = this.getLastPointBySet(set);
            if (punto) return teamAB == 'A' ? punto.tanteadorA : punto.tanteadorB;
            return '';
        },        

        startSet: function(set, ladoA, ladoB, servicio, formacionA, formacionB) {
            
            // add initialization point to host initial formations 
            let initSetPoint = {
                id_set: set, 
                id_punto: this.planilla.puntos.length, 
                ladoA: ladoA, 
                ladoB: ladoB, 
                servicio: servicio, 
                inicio: Date.now(), 
                fin: Date.now(), 
                tanteadorA: null, 
                tanteadorB: null, 
                rotacionA: formacionA, 
                rotacionB: formacionB
            }
            this.planilla.puntos.push(initSetPoint);

            // add 0-0 point
            let startSetPoint = {
                id_set: set, 
                id_punto: this.planilla.puntos.length, 
                ladoA: ladoA, 
                ladoB: ladoB, 
                servicio: servicio, 
                inicio: Date.now(), 
                fin: null, 
                tanteadorA: 0, 
                tanteadorB: 0, 
                rotacionA: formacionA, 
                rotacionB: formacionB
            }
            this.planilla.puntos.push(startSetPoint);
            
            // set match status
            this.planilla.estado = this.calculateEstado();

            // Setea la planilla
            this.planillaStartSet(
                0, 
                this.planilla.equipoA.id, 
                this.planilla.equipoB.id, 
                ladoA, 
                ladoB, 
                servicio, 
                this.getRotacionNumeros(startSetPoint.rotacionA, 'A'), 
                this.getRotacionNumeros(startSetPoint.rotacionB, 'B'))

            // emit start set event
            this.$eventHub.$emit('startSet');
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');

            // send dash action
            if (set == 0) {
                this.dashSendAction(this.DASH_ACTIONS.presentation);
            } else {
                this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
            }

            // reset redo actions
            this.resetRedo();
        },

        getRotacionNumeros: function(rotacion, teamAB) {

            let jugadores;
            
            if (teamAB == 'A') jugadores = this.planilla.equipoA.jugadores;
            if (teamAB == 'B') jugadores = this.planilla.equipoB.jugadores;

            let ret = [];

            if (!rotacion) return ret;

            rotacion.map(rotacionId => {
                jugadores.map(jugador => {
                    if (jugador.id == rotacionId && jugador.tipo == 'jugador' && jugador.numero) {
                        ret.push(jugador.numero);
                    }
                })
            })

            return ret;
        },

        calculateEstado: function() {

            // inicioPartido
            // set1
            // entregaFormaciones2
            // set2
            // entregaFormaciones3
            // set3
            // entregaFormaciones4
            // set4
            // entregaFormaciones5
            // set5
            // finPartido

            let lastPoint = this.planilla.puntos.slice(-1).pop();
            let currentSet = lastPoint ? lastPoint.id_set : 0;
            let setEnded = false;
            let matchEnded = false;
            let estado = 'inicioPartido';
            
            // evaluates if this is the end of the set
            if (lastPoint &&
                ((lastPoint.tanteadorA >= this.planilla.settings.pointsBySet && lastPoint.tanteadorB < lastPoint.tanteadorA-1) ||
                 (lastPoint.tanteadorB >= this.planilla.settings.pointsBySet && lastPoint.tanteadorA < lastPoint.tanteadorB-1) ||
                 (this.isSetTieBreak(lastPoint.id_set) && lastPoint.tanteadorA >= this.planilla.settings.tieBreakPoints && lastPoint.tanteadorB < lastPoint.tanteadorA-1) ||
                 (this.isSetTieBreak(lastPoint.id_set) && lastPoint.tanteadorB >= this.planilla.settings.tieBreakPoints && lastPoint.tanteadorA < lastPoint.tanteadorB-1))) {
                setEnded = true;
            }
                    
            // evaluates if this is the end of the match
            if (lastPoint) {
                if (this.planilla.settings.obligatoryAllSets) {
                    // En formato obligatorio, el partido termina cuando el último set ha terminado
                    matchEnded = setEnded && (currentSet + 1 == this.planilla.settings.numberOfSets);
                } else {
                    matchEnded = (this.getSetsAB('A') > (this.planilla.settings.numberOfSets / 2)) ||
                                 (this.getSetsAB('B') > (this.planilla.settings.numberOfSets / 2));
                }
            }

            if (lastPoint) {
                if (currentSet == 0) estado = !setEnded ? 'set1' : 'entregaFormaciones2';
                if (currentSet == 1) estado = !setEnded ? 'set2' : 'entregaFormaciones3';
                if (currentSet == 2) estado = !setEnded ? 'set3' : 'entregaFormaciones4';
                if (currentSet == 3) estado = !setEnded ? 'set4' : 'entregaFormaciones5';
                if (currentSet == 4) estado = !setEnded ? 'set5' : 'finPartido';    
            }

            if (matchEnded) estado = 'finPartido';

            // set status for DB (live, upcoming, played)
            if (matchEnded) {
                this.planilla.status = 'played';
            } else {

                // set live when there is an active point (0-0 for initial rotations entered)
                if (this.currentPunto.id_punto) {
                    this.planilla.status = 'live';
                } else {
                    // any other status set upcoming
                    this.planilla.status = 'upcoming';
                }
            }

            return estado;
        },

        point: async function(side) {

            // reset redo actions
            this.resetRedo();

            // close previous point
            let prevPoint = this.currentPunto;
            prevPoint.fin = Date.now();

            // get the team that scored
            let team = (prevPoint.ladoA == side ? 'A' : 'B');

            // create new point
            let newPoint = JSON.parse(JSON.stringify(this.currentPunto));
            newPoint.id_punto++;
            newPoint.servicio = team;
            newPoint.inicio = Date.now();
            newPoint.fin = null;

            // score the point
            if (team == 'A') newPoint.tanteadorA++;
            if (team == 'B') newPoint.tanteadorB++;

            // rotate the team if needed
            if (prevPoint.servicio != team && team == 'A') this.rotate(newPoint.rotacionA);
            if (prevPoint.servicio != team && team == 'B') this.rotate(newPoint.rotacionB);

            // add new point
            this.planilla.puntos.push(newPoint);

            // set set score
            this.planilla.sets_a = this.getSetsAB('A');
            this.planilla.sets_b = this.getSetsAB('B');

            // store sheet info
            this.updateTanteadorPlanilla();
            this.addRotacionPuntoPlanilla();

            // report action event
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');
            this.$eventHub.$emit('point', {teamAB: team, side: side});

            // update sets by team
            this.planilla.estado = this.calculateEstado();

            // update dash scoreboard
            let estadistica = this.planilla.estadisticas[this.planilla.estadisticas.length-1];

            if (estadistica && estadistica.jugador) {
                await this.dashSendAction(this.DASH_ACTIONS.continue, {
                    jugador: this.getPlayerById(estadistica.jugador),
                    equipo: estadistica.equipo,
                    tipo: estadistica.tipo,
                    totalSet: this.getEstadisticaTotalByJugador(estadistica.jugador, estadistica.tipo, this.currentSet),
                    totalPartido: this.getEstadisticaTotalByJugador(estadistica.jugador, estadistica.tipo)
                })
            }

            // evaluates if this is the set end
            if ((newPoint.tanteadorA >= this.planilla.settings.pointsBySet && newPoint.tanteadorB < newPoint.tanteadorA-1) ||
                (newPoint.tanteadorB >= this.planilla.settings.pointsBySet && newPoint.tanteadorA < newPoint.tanteadorB-1) ||
                (this.isSetTieBreak(newPoint.id_set) && newPoint.tanteadorA >= this.planilla.settings.tieBreakPoints && newPoint.tanteadorB < newPoint.tanteadorA-1) ||
                (this.isSetTieBreak(newPoint.id_set) && newPoint.tanteadorB >= this.planilla.settings.tieBreakPoints && newPoint.tanteadorA < newPoint.tanteadorB-1)) {
                this.endSet();
            }
        },

        stopSet: async function(winnerTeam, notes) {

            let side = null;
            let lastPoint = this.isSetTieBreak(this.currentSet) ? 14 : 24;

            if (winnerTeam == this.planilla.equipoA.id) {
                this.currentPunto.tanteadorA = this.currentPunto.tanteadorB >= lastPoint ? this.currentPunto.tanteadorB + 1 : lastPoint;
                side = this.currentLadoA;
            }
            if (winnerTeam == this.planilla.equipoB.id) {
                this.currentPunto.tanteadorB = this.currentPunto.tanteadorA >= lastPoint ? this.currentPunto.tanteadorA + 1 : lastPoint;
                side = this.currentLadoB;
            }
            
            this.planilla.observaciones += `SET ${this.currentSet + 1} SUSPENDIDO - GANADOR ${winnerTeam}: ${notes}`;            

            await this.point(side);
        },

        stopMatch: function(winnerTeam, notes) {

            let lastPoint = this.isSetTieBreak(this.currentSet) ? 15 : 25;
            let numberOfSets = Math.ceil(this.planilla.settings.numberOfSets / 2);
            let winnerSets = 0;
            let currentPunto = this.currentPunto;

            // finish current set
            if (winnerTeam == this.planilla.equipoA.id) {
                winnerSets = this.planilla.sets_a + 1;
            }
            if (winnerTeam == this.planilla.equipoB.id) {
                winnerSets = this.planilla.sets_b + 1;
            }

            // add last point of current set
            let loserCurrentScore = winnerTeam == this.planilla.equipoA.id ? this.currentScoreB : this.currentScoreA;
            let winnerNewScore = loserCurrentScore >= lastPoint - 1 ? loserCurrentScore + 2 : lastPoint;
            this.planilla.puntos.push({
                id_set: this.currentSet, 
                id_punto: this.planilla.puntos.length, 
                ladoA: this.currentLadoA, 
                ladoB: this.currentLadoB, 
                servicio: winnerTeam == this.planilla.equipoA.id ? 'A' : 'B', 
                inicio: Date.now(), 
                fin: Date.now(), 
                tanteadorA: winnerTeam == this.planilla.equipoA.id ? winnerNewScore : loserCurrentScore, 
                tanteadorB: winnerTeam == this.planilla.equipoB.id ? winnerNewScore : loserCurrentScore, 
                rotacionA: winnerTeam == this.planilla.equipoA.id ? this.rotate(currentPunto.rotacionA) : currentPunto.rotacionA, 
                rotacionB: winnerTeam == this.planilla.equipoB.id ? this.rotate(currentPunto.rotacionB) : currentPunto.rotacionB, 
            });

            for (let i=winnerSets;i<numberOfSets;i++) {

                let firstPoint = this.getSetInitialPoint(this.currentSet);

                // add points for every remaining set
                let point = {
                    id_set: this.currentSet+1, 
                    id_punto: this.planilla.puntos.length, 
                    ladoA: this.currentLadoA == 'I' ? 'D' : 'I', 
                    ladoB: this.currentLadoB == 'I' ? 'D' : 'I', 
                    servicio: firstPoint.servicio == 'A' ? 'B' : 'A', 
                    inicio: Date.now(), 
                    fin: Date.now(), 
                    tanteadorA: winnerTeam == this.planilla.equipoA.id ? lastPoint : 0, 
                    tanteadorB: winnerTeam == this.planilla.equipoB.id ? lastPoint : 0, 
                    rotacionA: currentPunto.rotacionA, 
                    rotacionB: currentPunto.rotacionB
                }
                this.planilla.puntos.push(point);
            }

            this.planilla.observaciones += `PARTIDO SUSPENDIDO - GANADOR ${winnerTeam}: ${notes}`;

            // change match status
            this.planilla.estado = 'finPartido';

            // emit end set event for match comp to handle it
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');
            this.$eventHub.$emit('endMatch');
        },

        endSet: async function() {

            // updates planilla
            let planillaSet = this.planilla.planilla.sets[this.currentSet];
            planillaSet.horaFin = Date.now();

            // evaluates if this is the end of the match
            const isMatchOver = this.planilla.settings.obligatoryAllSets
                ? (this.currentSet + 1 == this.planilla.settings.numberOfSets)
                : ((this.planilla.sets_a > (this.planilla.settings.numberOfSets / 2)) ||
                   (this.planilla.sets_b > (this.planilla.settings.numberOfSets / 2)));

            if (isMatchOver) {

                // emit end set event for match comp to handle it
                this.$eventHub.$emit('endMatch');

                // automatically set player of the match
                this.$root.planilla.jugadorPartido = this.planilla.AIScore && this.planilla.AIScore.length ? this.planilla.AIScore[0].id : null;

                // send dash action
                await this.dashSendAction(this.DASH_ACTIONS.endMatch);

            } else {

                // emit end set event for match comp to handle it
                this.$eventHub.$emit('endSet');

                // send dash action
                await this.dashSendAction(this.DASH_ACTIONS.endSet);
            }

            // report action event
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');
        },

        updateTanteadorPlanilla: function() {

            let planillaSet = this.planilla.planilla.sets[this.currentSet];

            planillaSet.tanteadorA = this.currentPunto.tanteadorA;
            planillaSet.tanteadorB = this.currentPunto.tanteadorB;
        },

        addRotacionPuntoPlanilla: function() {

            let planillaSet = this.planilla.planilla.sets[this.currentSet];

            if (this.prevPunto.servicio != this.currentPunto.servicio && this.currentPunto.servicio == 'A') planillaSet.equipoB.rotacionTanteador.push(this.prevPunto.tanteadorB);
            if (this.prevPunto.servicio != this.currentPunto.servicio && this.currentPunto.servicio == 'B') planillaSet.equipoA.rotacionTanteador.push(this.prevPunto.tanteadorA);
        },

        removeRotacionPuntoPlanilla: function() {

            let planillaSet = this.planilla.planilla.sets[this.currentSet];

            if (this.prevPunto.servicio != this.currentPunto.servicio && this.currentPunto.servicio == 'A') planillaSet.equipoB.rotacionTanteador.pop();
            if (this.prevPunto.servicio != this.currentPunto.servicio && this.currentPunto.servicio == 'B') planillaSet.equipoA.rotacionTanteador.pop();
        },

        rotate: function(arr) {
            arr.push(arr.shift());
            return arr;
        },

        getPlayerById: function(id) {

            let ret = null;

            this.planilla.equipoA.jugadores.map(jugador => {
                if (jugador.id == id) ret = jugador;
            })

            this.planilla.equipoB.jugadores.map(jugador => {
                if (jugador.id == id) ret = jugador;
            })

            return ret;
        },

        planillaStartSet: function(set, idEquipoA, idEquipoB, ladoA, ladoB, servicio, formacionInicialA, formacionInicialB) {

            let planillaSet = {
                horaInicio: Date.now(),
                horaFin: null,
                idEquipoA: idEquipoA,
                idEquipoB: idEquipoB,
                ladoA: ladoA,
                ladoB: ladoB,
                servicio: servicio,
                id_set: set,
                tanteadorA: 0,
                tanteadorB: 0,
                equipoA: {
                    formacionInicial: formacionInicialA,
                    formacionCambios: [null, null, null, null, null, null],
                    formacionCambiosCerrados: [false, false, false, false, false, false],
                    formacionCambiosTanteador: [null, null, null, null, null, null],
                    formacionCambiosCerradosTanteador: [null, null, null, null, null, null],
                    tiemposTanteador: [null, null],
                    rotacionTanteador: servicio == 'B' ? ['0'] : []
                },
                equipoB: {
                    formacionInicial: formacionInicialB,
                    formacionCambios: [null, null, null, null, null, null],
                    formacionCambiosCerrados: [false, false, false, false, false, false],
                    formacionCambiosTanteador: [null, null, null, null, null, null],
                    formacionCambiosCerradosTanteador: [null, null, null, null, null, null],
                    tiemposTanteador: [null, null],
                    rotacionTanteador: servicio == 'A' ? ['0'] : []
                }
            }

            this.planilla.planilla.sets.push(planillaSet);
        },

        sanction: function(idEquipo, jugador, tipo) {

          let sanction = {
            id_set: this.currentSet, 
            id_punto: this.currentPuntoIndex, 
            id_equipo: idEquipo, 
            id_persona: jugador.id,
            numero: jugador.numero,
            tipo: 'sanction:' + tipo,
            inicio: Date.now(),
            fin: Date.now()
          }

          // add events to match
          this.planilla.eventos.push(sanction);

          // report action event
          this.$eventHub.$emit('action');
          this.$eventHub.$emit('persist');
        },

        timeoutStart: function(equipoAB) {

            this.planilla.estado = 'timeout';
            this.$eventHub.$emit('timeout', {equipoAB: equipoAB});
        },
        
        timeout: function(equipoAB, inicio, fin) {

            let idEquipo = equipoAB == 'A' ? this.equipoA : this.equipoB;

            let timeout = {
              id_set: this.currentSet, 
              id_punto: this.currentPuntoIndex, 
              id_equipo: idEquipo, 
              tipo: 'tiempo',
              inicio: inicio,
              fin: fin
            }

            // add events to match
            this.planilla.eventos.push(timeout);

            // update sheet
            let tiempos = this.getTiemposByTeamABSet(equipoAB, this.currentSet);
            if (equipoAB == 'A') this.planilla.planilla.sets[this.currentSet].equipoA.tiemposTanteador = tiempos;
            if (equipoAB == 'B') this.planilla.planilla.sets[this.currentSet].equipoB.tiemposTanteador = tiempos;

            if (tiempos.length >= this.planilla.settings.tiemposTecnicosPorSet) {
                this.showWarning('Atencion', `Equipo ${equipoAB}: ${idEquipo} no tiene mas tiempos tecnicos disponibles en este set.`);
            }

            // report action event
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');
        },

        substitution: function(equipo, idJugadorIn, numeroJugadorIn, idJugadorOut, numeroJugadorOut) {

            let equipoAB = equipo == this.equipoA ? 'A' : 'B';

            let substitution = {
                id_set: this.currentSet, 
                id_punto: this.currentPuntoIndex, 
                id_equipo: equipo, 
                id_persona: idJugadorIn, 
                numero: numeroJugadorIn,
                id_persona_out: idJugadorOut,
                numero_out: numeroJugadorOut,
                tipo: 'cambio',
                inicio: Date.now(),
                fin: Date.now()    
            }

            // add events to match
            this.planilla.eventos.push(substitution);

            // replace players in rotation
            if (equipoAB == 'A') this.currentPunto.rotacionA = this.currentPunto.rotacionA.map(id => id == substitution.id_persona_out ? substitution.id_persona : id)
            if (equipoAB == 'B') this.currentPunto.rotacionB = this.currentPunto.rotacionB.map(id => id == substitution.id_persona_out ? substitution.id_persona : id)

            // update sheet
            this.substitutionsUpdatePlanilla(equipoAB);

            // warning for substitution max reached
            let cambios = this.getCambiosByTeamABSet(equipoAB, this.currentSet);
            if (cambios.length >= this.planilla.settings.cambiosPorSet) {
                this.showWarning('Atencion', `Equipo ${equipoAB}: ${equipo} no tiene mas cambios disponibles en este set.`);
            }

            // report action event
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');

        },

        substitutionsUpdatePlanilla(equipoAB) {

            // update sheet
            let cambiosFormacion = this.getCambiosFormacionByTeamABSet(equipoAB, this.currentSet);
            let cambiosFormacionTanteador = this.getCambiosFormacionTanteadorByTeamABSet(equipoAB, this.currentSet);
            let cambiosFormacionCerrados = this.getCambiosFormacionCerradosByTeamABSet(equipoAB, this.currentSet);
            let cambiosFormacionCerradosTanteador = this.getCambiosFormacionCerradosTanteadorByTeamABSet(equipoAB, this.currentSet);

            if (equipoAB == 'A') {
                this.planilla.planilla.sets[this.currentSet].equipoA.formacionCambios = cambiosFormacion;
                this.planilla.planilla.sets[this.currentSet].equipoA.formacionCambiosTanteador = cambiosFormacionTanteador;
                this.planilla.planilla.sets[this.currentSet].equipoA.formacionCambiosCerrados = cambiosFormacionCerrados;
                this.planilla.planilla.sets[this.currentSet].equipoA.formacionCambiosCerradosTanteador = cambiosFormacionCerradosTanteador;
            }
            if (equipoAB == 'B') {
                this.planilla.planilla.sets[this.currentSet].equipoB.formacionCambios = cambiosFormacion;
                this.planilla.planilla.sets[this.currentSet].equipoB.formacionCambiosTanteador = cambiosFormacionTanteador;
                this.planilla.planilla.sets[this.currentSet].equipoB.formacionCambiosCerrados = cambiosFormacionCerrados;
                this.planilla.planilla.sets[this.currentSet].equipoB.formacionCambiosCerradosTanteador = cambiosFormacionCerradosTanteador;
            }            
        },

        actionHandler() {
            if (this.planilla.mode == 'practice' || this.planilla.mode == 'certification' || this.planilla.mode == 'device-validation') return;
            this.savePlanilla();
        },

        readConfiguration() {

            let storeConfig = JSON.parse(localStorage.getItem('rulerConfiguration'));

            if (storeConfig) {
                //if (storeConfig.apiURL) this.config.apiURL = storeConfig.apiURL;
                if (storeConfig.dashHost) this.config.dashHost = storeConfig.dashHost;
                if (storeConfig.dashMode) this.config.dashMode = storeConfig.dashMode;
                if (storeConfig.cambioDeLadoEntreSets) this.config.cambioDeLadoEntreSets = storeConfig.cambioDeLadoEntreSets;
                if (storeConfig.tipoEstadisticas) this.config.tipoEstadisticas = storeConfig.tipoEstadisticas;
                if (storeConfig.cambiosPorSet) this.config.cambiosPorSet = storeConfig.cambiosPorSet;
                if (storeConfig.cambiosPermitirAbiertos != undefined) this.config.cambiosPermitirAbiertos = storeConfig.cambiosPermitirAbiertos;
                if (storeConfig.cambiosPermitirReingresoCerrados != undefined) this.config.cambiosPermitirReingresoCerrados = storeConfig.cambiosPermitirReingresoCerrados;
                if (storeConfig.language != undefined) this.config.language = storeConfig.language;
            }
        },

        saveConfiguration() {

            let config = {
                apiURL: this.config.apiURL,
                dashHost: this.config.dashHost,
                dashMode: this.config.dashMode,
                cambioDeLadoEntreSets: this.config.cambioDeLadoEntreSets,
                tipoEstadisticas: this.config.tipoEstadisticas,
                cambiosPorSet: this.config.cambiosPorSet,
                cambiosPermitirAbiertos: this.config.cambiosPermitirAbiertos,
                cambiosPermitirReingresoCerrados: this.config.cambiosPermitirReingresoCerrados,
                language: this.config.language
            }

            return localStorage.setItem('rulerConfiguration', JSON.stringify(config));
        },

        getEstadisticaTipoByEquipoSet(tipo, set, equipo) {
            let ret = 0;
            this.planilla.estadisticas.map(estadistica => {
                if (estadistica.set == set && estadistica.equipo == equipo && estadistica.tipo == tipo) {
                    ret++;
                }
            })
            return ret;
        },

        getEstadisticaTipoByPlayer(tipo, jugadorId) {
            let ret = 0;
            this.planilla.estadisticas.map(estadistica => {
                if (estadistica.tipo == tipo && estadistica.jugador == jugadorId) {
                    ret++;
                }
            })
            return ret;
        },

        getPuntosDisputadosByPlayer(jugadorId) {
            return this.planilla.puntos.filter(punto => (punto.tanteadorA !== null && punto.tanteadorB !== null && punto.rotacionA.indexOf(jugadorId) > -1 || punto.rotacionA.indexOf(jugadorId) > -1)).length;
        },

        pointIsSetTieBreak: function(point) {
            return point.id_set ? (point.id_set+1 == this.$root.planilla.settings.numberOfSets) : 0;
        },

        pointIsSetPoint: function(point) {
            let ret = false;
            let esTieBreak = this.pointIsSetTieBreak(point);

            if ((!esTieBreak && ((point.tanteadorA >= this.$root.planilla.settings.pointsBySet - 2 && point.tanteadorB >= point.tanteadorA) ||
                                 (point.tanteadorB >= this.$root.planilla.settings.pointsBySet - 2 && point.tanteadorA >= point.tanteadorB))) ||
                ( esTieBreak && ((point.tanteadorA >= this.$root.planilla.settings.tieBreakPoints - 2 && point.tanteadorB >= point.tanteadorA) ||
                                 (point.tanteadorB >= this.$root.planilla.settings.tieBreakPoints - 2 && point.tanteadorA >= point.tanteadorB)))) {
                ret = true;
            }
            return ret;
        },

        calculateAIScore() {

            let config = {
                equipoGanador: 1.3,
                momentoSetNormalPunto: 1,
                momentoSetDefinicionPunto: 1.5,
                momentoSetSetPointPunto: 2,
                momentoSetNormalError: 1,
                momentoSetDefinicionError: 1.5,
                momentoSetSetPointError: 2,
                esTieBreakPunto: 1.2,
                esTieBreakError: 1.2,
                porcentajePuntosTotalLimite: 0.16,
                porcentajePuntosTotalScore: 1.3,
                porcentajeErrorTotalLimite: 0.16,
                porcentajeErrorTotalScore: 0.769,
                mejorJugadorSetScore: 20,
                armadorDistribucionScore: 20,
                armadorPuntosAtaqueMultiplier: 2,
                armadorErroresMultiplier: 0.5,
                armadorAtaqueSobreTotalLimite: 0.5,
                armadorAtaqueSobreTotalScore: 20,
                liberoAtaqueSobreTotalLimite: 0.5,
                liberoAtaqueSobreTotalScore: 20,
                liberoAtaqueMayorContraAtaqueScore: 20,
                liberoLikesMultiplier: 1.5,
                liberoDisLikesMultiplier: 1.5,
                liberoErroresMultiplier: 1.5
            }

            let scoreEquipoA = {puntos: 0, errores: 0};
            let scoreEquipoB = {puntos: 0, errores: 0};

            let scores = this.$root.planilla.estadisticas.map(estadistica => {
                
                let punto = this.$root.planilla.puntos.find(punto => punto.id_punto == estadistica.punto);

                // fix for broken stats
                if (!punto) punto = {};

                let equipo = this.$root.equipoA == estadistica.equipo ? this.$root.planilla.equipoA : this.$root.planilla.equipoB;
                let jugador = equipo.jugadores.find(jugador => jugador.id == estadistica.jugador);
                let multiplier = 1;
                let multiplierList = [];
                let esTieBreak = this.pointIsSetTieBreak(punto);
                let valor = 1;
                const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(estadistica.tipo) != -1);
                const esError = (['errorSaque', 'error'].indexOf(estadistica.tipo) != -1);

                if (estadistica.equipo == this.$root.equipoA) {
                    if (esPunto) scoreEquipoA.puntos++;
                    if (esError) scoreEquipoA.errores++;
                } else {
                    if (esPunto) scoreEquipoB.puntos++;
                    if (esError) scoreEquipoB.errores++;
                }

                // Por Estadistica
                // Set del partido (es Tie-Break?)
                if (this.pointIsSetTieBreak(punto)) {
                    if (esPunto) {
                        multiplier *= config.esTieBreakPunto;
                        multiplierList.push('esTieBreakPunto');
                    }
                    if (esError) {
                        multiplier *= config.esTieBreakError;
                        multiplierList.push('esTieBreakError');
                    }
                }

                // Momento del set (set point)
                if (this.pointIsSetPoint(punto)) {
                    if (esPunto) {
                        multiplier *= config.momentoSetSetPointPunto;
                        multiplierList.push('momentoSetSetPointPunto');
                    }
                    if (esError) {
                        multiplier *= config.momentoSetSetPointError;
                        multiplierList.push('momentoSetSetPointError');
                    }
                }

                // Momento del set (definicion)
                if (!this.pointIsSetPoint(punto) && 
                    ((punto.tanteadorA >= 20 && punto.tanteadorB >= 20) || 
                     (punto.tanteadorA >= 10 && punto.tanteadorB >= 10 && esTieBreak))) {
                    if (esPunto) {
                        multiplier *= config.momentoSetDefinicionPunto;
                        multiplierList.push('momentoSetDefinicionPunto');
                    }
                    if (esError) {
                        multiplier *= config.momentoSetDefinicionError;
                        multiplierList.push('momentoSetDefinicionError');
                    }
                }

                if (esPunto) valor = 10 * multiplier;
                if (esError) valor = 10 * multiplier * -1;

                return {
                    set: estadistica.set + 1,
                    punto: punto ? `${punto.tanteadorA}-${punto.tanteadorB}` : '',
                    multiplierList: multiplierList,
                    multiplier: multiplier,
                    equipo: estadistica.equipo,
                    jugadorId: jugador.id,
                    jugador: `${jugador.numero} - ${jugador.apellido.toUpperCase()}, ${jugador.nombre.toUpperCase().substr(0,1)}`,
                    posicion: estadistica.posicion,
                    tipo: estadistica.tipo,
                    valor: valor
                }
            })

            let scoreByPlayer = [];

            for (let score of scores) {

                const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(score.tipo) != -1);
                const esError = (['errorSaque', 'error'].indexOf(score.tipo) != -1);

                let playerScore = scoreByPlayer.find(item => item.id == score.jugadorId);
                if (!playerScore) {
                    scoreByPlayer.push({
                        id: score.jugadorId,
                        player: score.jugador,
                        team: score.equipo,
                        multiplier: 1,
                        multiplierList: [],
                        rol: '',
                        total: score.valor,
                        puntos: esPunto ? 1 : 0,
                        errores: esError ? 1 : 0,
                        TBP: score.multiplierList.includes('esTieBreakPunto') ? 1 : 0,
                        TBE: score.multiplierList.includes('esTieBreakError') ? 1 : 0,
                        SPP: score.multiplierList.includes('momentoSetSetPointPunto') ? 1 : 0,
                        SPE: score.multiplierList.includes('momentoSetSetPointError') ? 1 : 0,
                        SDP: score.multiplierList.includes('momentoSetDefinicionPunto') ? 1 : 0,
                        SDE: score.multiplierList.includes('momentoSetDefinicionError') ? 1 : 0,
                        EG: 'No',
                        PA: 'No',
                        PE: 'No'
                    })
                } else {
                    playerScore.total += score.valor;
                    playerScore.puntos += esPunto ? 1 : 0;
                    playerScore.errores += esError ? 1 : 0;
                    playerScore.TBP += score.multiplierList.includes('esTieBreakPunto') ? 1 : 0;
                    playerScore.TBE += score.multiplierList.includes('esTieBreakError') ? 1 : 0;
                    playerScore.SPP += score.multiplierList.includes('momentoSetSetPointPunto') ? 1 : 0;
                    playerScore.SPE += score.multiplierList.includes('momentoSetSetPointError') ? 1 : 0;
                    playerScore.SDP += score.multiplierList.includes('momentoSetDefinicionPunto') ? 1 : 0;
                    playerScore.SDE += score.multiplierList.includes('momentoSetDefinicionError') ? 1 : 0;
                }
            }

            // Por Jugador
            scoreByPlayer = scoreByPlayer.map(score => {

                // Extra: Equipo ganador
                let equipoGanador = (this.getSetsAB('A') > this.getSetsAB('B')) ? this.$root.equipoA : this.$root.equipoB;
                if (score.team == equipoGanador) {
                    score.total *= config.equipoGanador;
                    score.multiplierList.push('equipoGanador');
                    score.EG = 'Si';
                }

                let scoreEquipos = score.team == this.$root.equipoA ? scoreEquipoA : scoreEquipoB;

                // Extra: Porcentaje de Puntos sobre el total de mi equipo
                if (score.puntos / scoreEquipos.puntos > config.porcentajePuntosTotalLimite) {
                    score.total *= config.porcentajePuntosTotalScore;
                    score.multiplierList.push('porcentajePuntosTotal');
                    score.PA = 'Si';
                }

                // Extra: Porcentaje de Errores sobre el total
                if (score.errores / scoreEquipos.errores > config.porcentajeErrorTotalLimite) {
                    score.total *= config.porcentajeErrorTotalScore;
                    score.multiplierList.push('porcentajeErrorTotal');
                    score.PE = 'Si';
                }

                score.total = Math.round(score.total);

                return score;
            })

            this.planilla.AIScore = scoreByPlayer;
            this.planilla.AIScore.sort((a,b) => a.total - b.total).reverse();
        },

        generateVersionId: function() {
            return crypto && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        },

        prepararPlanilla() {

            this.$root.calculateAIScore();

            this.calculateDuracionPartido();

            // force recalculation of sets (due to an old bug)
            this.planilla.sets_a = this.getSetsAB('A');
            this.planilla.sets_b = this.getSetsAB('B');

            this.planilla.progresion = this.getProgresion();
            
            let mejores = this.getEstadisticasJugadoresDestacados();

            this.planilla.maximoAnotador = mejores.maximoAnotador;
            this.planilla.mejorSacador = mejores.mejorSacador;
            this.planilla.mejorBloqueador = mejores.mejorBloqueador;

            this.planilla.estadisticasSet = {};

            for (let i=0;i<this.planilla.planilla.sets.length;i++) {

                // set tiempos & cambios
                this.planilla.planilla.sets[i].tiemposA = this.getTiemposByTeamABSet('A', i).length;
                this.planilla.planilla.sets[i].tiemposB = this.getTiemposByTeamABSet('B', i).length;
                this.planilla.planilla.sets[i].cambiosA = this.getCambiosByTeamABSet('A', i).length;
                this.planilla.planilla.sets[i].cambiosB = this.getCambiosByTeamABSet('B', i).length;
                
                // set estadisticas set
                let setEstadistica = {
                    ataquesA: this.getEstadisticaTipoByEquipoSet('puntoAtaque', i, this.equipoA),
                    ataquesB: this.getEstadisticaTipoByEquipoSet('puntoAtaque', i, this.equipoB),
                    acesA: this.getEstadisticaTipoByEquipoSet('puntoSaque', i, this.equipoA),
                    acesB: this.getEstadisticaTipoByEquipoSet('puntoSaque', i, this.equipoB),
                    bloqueosA: this.getEstadisticaTipoByEquipoSet('puntoBloqueo', i, this.equipoA),
                    bloqueosB: this.getEstadisticaTipoByEquipoSet('puntoBloqueo', i, this.equipoB),
                    erroresSaqueA: this.getEstadisticaTipoByEquipoSet('errorSaque', i, this.equipoA),
                    erroresSaqueB: this.getEstadisticaTipoByEquipoSet('errorSaque', i, this.equipoB),
                    erroresNoForzadosA: this.getEstadisticaTipoByEquipoSet('error', i, this.equipoA),
                    erroresNoForzadosB: this.getEstadisticaTipoByEquipoSet('error', i, this.equipoB)
                }
                this.planilla.estadisticasSet['set' + i] = setEstadistica;
            }

            // estadisticas by player
            this.planilla.estadisticasJugador = [];
            this.planilla.equipoA.jugadores.concat(this.planilla.equipoB.jugadores)
                .filter(jugador => jugador.numero)
                .map(jugador => {     
                    
                    let AIScore = (this.planilla.AIScore && Array.isArray(this.planilla.AIScore)) 
                        ? this.planilla.AIScore.find(item => item.id == jugador.id) 
                        : null;
                    this.planilla.estadisticasJugador.push({
                        id: jugador.id,
                        nombre: jugador.apellido,
                        puntosDisputados: this.getPuntosDisputadosByPlayer(jugador.id),
                        erroresSaque: this.getEstadisticaTipoByPlayer('errorSaque', jugador.id),
                        ataques: this.getEstadisticaTipoByPlayer('puntoAtaque', jugador.id),
                        erroresNoForzados: this.getEstadisticaTipoByPlayer('error', jugador.id),
                        aces: this.getEstadisticaTipoByPlayer('puntoSaque', jugador.id),
                        bloqueos: this.getEstadisticaTipoByPlayer('puntoBloqueo', jugador.id),
                        AIScore: AIScore ? AIScore.total : 0
                    }
                )
            })

            // creates a copy to persist
            let planillaFormatted = JSON.parse(JSON.stringify(this.planilla));

            // adjust timezones on relevant date-times
            for (let i=0; i<planillaFormatted.planilla.sets.length;i++) {
                if (planillaFormatted.planilla.sets[i].horaInicio) planillaFormatted.planilla.sets[i].horaInicio += new Date().getTimezoneOffset() * 60 * 1000 * -1;
                if (planillaFormatted.planilla.sets[i].horaFin) planillaFormatted.planilla.sets[i].horaFin += new Date().getTimezoneOffset() * 60 * 1000 * -1;
            }

            return planillaFormatted;
            
        },

        persistHandler() {
            
            if (this.forceOffline) return;

            if (this.planilla.mode == 'practice' || this.planilla.mode == 'certification' || this.planilla.mode == 'device-validation') return;
            
            let planillaFormatted = this.prepararPlanilla();

            // Assign a stable versionId so retries reuse the same ID for deduplication
            const existing = this.planillasToPersist.find(ptp => ptp.id_partido == planillaFormatted.id_partido);
            planillaFormatted.versionId = existing ? existing.versionId : this.generateVersionId();
            this.planilla.versionId = planillaFormatted.versionId;

            // add planilla to persistence array begginning
            this.planillasToPersist = this.planillasToPersist.filter(ptp => ptp.id_partido != planillaFormatted.id_partido);
            this.planillasToPersist.unshift(planillaFormatted);

            // trigger persist function
            this.persistPlanillas();
        },

        persistPlanillas: async function() {
            const DEBOUNCE_DELAY = 2000; // 2 seconds

            // Clear any existing timeout
            if (this.persistTimeout) {
                clearTimeout(this.persistTimeout);
            }

            // Always schedule for later, canceling any previous scheduled execution
            this.persistTimeout = setTimeout(() => {
                this.executePersist().catch(err => console.error('executePersist error:', err));
            }, DEBOUNCE_DELAY);
        },

        executePersist: async function() {
            if (this.isPersisting) return;
            if (!this.socket || !this.socket.connected) return;
            this.isPersisting = true;
            this.lastPersistTimestamp = Date.now();

            try {
                for (let pf of this.planillasToPersist) {

                    console.log(`[rulerSave] ${new Date().toISOString()} partido=${pf.id_partido} versionId=${pf.versionId}`);
                    let response = await this.socket.timeout(3000).emitWithAck("rulerSave", pf);

                    // if planilla was saved, remove from planillasToPersistArray
                    if (response == 'ok') {
                        this.planillasToPersist = this.planillasToPersist.filter(ptp => ptp.id_partido != pf.id_partido);
                    }

                    // Wait 2 seconds before processing next planilla
                    if (this.planillasToPersist.length > 1) {
                        await new Promise(resolve => setTimeout(resolve, 2000));
                    }
                }
            } finally {
                this.isPersisting = false;
            }
        },

        calculateDuracionPartido: function() {
            
            let start = this.getSetInitialPoint(0).inicio;
            let end = Date.now();
            let duration = 0;

            if (start) {
                let diff = Math.abs(end - start);
                duration = Math.floor((diff/1000));
            }

            this.planilla.duracion = duration;
        },

        resetRedo: function() {

            this.planilla.undoList = [];
        },

        undoAction: async function() {

            // search last action
            let lastEvent = this.acciones[0];

            if (!lastEvent) return;

            // add info to the undo list
            if (!this.planilla.undoList) this.planilla.undoList = [];

            // punto
            if (lastEvent.tipo == 'Punto') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-last-point'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    noCloseOnBackdrop: true
                })
                .then(async (value) => {
                    if (value) {

                        // remove rotacion from planilla
                        this.removeRotacionPuntoPlanilla();

                        // remove the last point stored
                        let lastPoint = this.planilla.puntos.pop();
                        this.planilla.undoList.push({tipo: lastEvent.tipo, event: lastEvent, data: lastPoint});

                        // update sets and status
                        this.planilla.sets_a = this.getSetsAB('A');
                        this.planilla.sets_b = this.getSetsAB('B');
                        this.planilla.estado = this.calculateEstado();

                        // update tanteador planilla
                        this.updateTanteadorPlanilla();

                        // remove estadistica
                        if (!this.planilla.undoEstadisticasList) this.planilla.undoEstadisticasList = [];
                        this.planilla.undoEstadisticasList.push(this.planilla.estadisticas.pop());

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');
                        
                        // update dash scoreboard
                        await this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
                    }
                })
            }

            // fin set
            if (lastEvent.tipo == 'Fin Set') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-end-set'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async (value) => {
                    if (value) {

                        // remove rotacion from planilla
                        this.removeRotacionPuntoPlanilla();

                        // remove the last point stored
                        let lastPoint = this.planilla.puntos.pop();
                        this.planilla.undoList.push({tipo: lastEvent.tipo, event: lastEvent, data: lastPoint});
                        this.planilla.planilla.sets[this.currentSet].horaFin = null;

                        // update sets and status
                        this.planilla.sets_a = this.getSetsAB('A');
                        this.planilla.sets_b = this.getSetsAB('B');
                        this.planilla.estado = this.calculateEstado();

                        // update tanteador planilla
                        this.updateTanteadorPlanilla();

                        // remove estadistica
                        if (!this.planilla.undoEstadisticasList) this.planilla.undoEstadisticasList = [];
                        this.planilla.undoEstadisticasList.push(this.planilla.estadisticas.pop());

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');
                        
                        // update dash scoreboard
                        await this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
                    }
                })
            }
            
            // cambio
            if (lastEvent.tipo == 'Cambio') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-last-substitution'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async (value) => {
                    if (value) {

                        // remove event
                        let substitution = this.planilla.eventos.pop();
                        let equipoAB = (substitution.id_equipo == this.equipoA ? 'A' : 'B');

                        // replace players in rotation
                        if (equipoAB == 'A') this.currentPunto.rotacionA = this.currentPunto.rotacionA.map(id => id == substitution.id_persona ? substitution.id_persona_out : id)
                        if (equipoAB == 'B') this.currentPunto.rotacionB = this.currentPunto.rotacionB.map(id => id == substitution.id_persona ? substitution.id_persona_out : id)

                        // update sheet
                        this.substitutionsUpdatePlanilla(equipoAB);

                        // add to undolist
                        this.planilla.undoList.push({tipo: lastEvent.tipo, event: lastEvent, data: substitution});

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');
                        
                        // update dash scoreboard
                        await this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
                    }
                })
            }

            // tiempo
            if (lastEvent.tipo == 'Tiempo Tecnico') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-last-timeout'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async (value) => {
                    if (value) {

                        // remove event
                        let timeout = this.planilla.eventos.pop();
                        let equipoAB = (timeout.id_equipo == this.equipoA ? 'A' : 'B');

                        // update sheet
                        let tiempos = this.getTiemposByTeamABSet(equipoAB, this.currentSet);
                        if (equipoAB == 'A') this.planilla.planilla.sets[this.currentSet].equipoA.tiemposTanteador = tiempos;
                        if (equipoAB == 'B') this.planilla.planilla.sets[this.currentSet].equipoB.tiemposTanteador = tiempos;

                        // add to undolist
                        this.planilla.undoList.push({tipo: lastEvent.tipo, event: lastEvent, data: timeout});

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');

                        // update dash scoreboard
                        await this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
                    }
                })
            }

            // sancion
            if (lastEvent.tipo == 'Sancion') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-last-sanction'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {

                        // remove event
                        let sanction = this.planilla.eventos.pop();

                        // add to undolist
                        this.planilla.undoList.push({tipo: lastEvent.tipo, event: lastEvent, data: sanction});

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');
                    }
                })
            }

            // inicio set
            if (lastEvent.tipo == 'Inicio Set') {

                this.$bvModal.msgBoxConfirm(i18n.t('are-you-sure-undo-set-start'), {
                    title: i18n.t('undo'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: i18n.t('confirm'),
                    cancelTitle: i18n.t('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {

                        // remove event
                        this.planilla.puntos.pop();
                        this.planilla.puntos.pop();

                        // update sets and status
                        this.planilla.sets_a = this.getSetsAB('A');
                        this.planilla.sets_b = this.getSetsAB('B');
                        this.planilla.estado = this.calculateEstado();

                        // remueve la inicializacion de la planilla
                        this.planilla.planilla.sets.pop();

                        // report action event
                        this.$eventHub.$emit('action');
                        this.$eventHub.$emit('persist');
                    }
                })
            }
        },

        redoAction: function() {

            if (!this.planilla.undoList || !this.planilla.undoList.length) return;

            let lastUndo = this.planilla.undoList.pop();

            // punto (fin set / partido)
            if (lastUndo.tipo == 'Punto') {

                // re-add the point undoed
                this.planilla.puntos.push(lastUndo.data);

                // update sets and status
                this.planilla.sets_a = this.getSetsAB('A');
                this.planilla.sets_b = this.getSetsAB('B');
                this.planilla.estado = this.calculateEstado();
                
                // re-add the estadistica
                this.planilla.estadisticas.push(this.planilla.undoEstadisticasList.pop());

                this.updateTanteadorPlanilla();
                this.addRotacionPuntoPlanilla();
            }

            if (lastUndo.tipo == 'Fin Set') {

                // re-add the point undoed
                this.planilla.puntos.push(lastUndo.data);

                // update sets and status
                this.planilla.sets_a = this.getSetsAB('A');
                this.planilla.sets_b = this.getSetsAB('B');
                this.planilla.estado = this.calculateEstado();

                // re-add the estadistica
                this.planilla.estadisticas.push(this.planilla.undoEstadisticasList.pop());

                this.updateTanteadorPlanilla();
                this.addRotacionPuntoPlanilla();
                this.endSet();
            }

            // cambio
            if (lastUndo.tipo == 'Cambio') {

                let substitution = lastUndo.data;

                // re-add substitution to event list
                this.planilla.eventos.push(substitution);

                let equipoAB = (substitution.id_equipo == this.equipoA ? 'A' : 'B');

                // replace players in rotation
                if (equipoAB == 'A') this.currentPunto.rotacionA = this.currentPunto.rotacionA.map(id => id == substitution.id_persona_out ? substitution.id_persona : id)
                if (equipoAB == 'B') this.currentPunto.rotacionB = this.currentPunto.rotacionB.map(id => id == substitution.id_persona_out ? substitution.id_persona : id)

                // update sheet
                this.substitutionsUpdatePlanilla(equipoAB);

            }

            // tiempo
            if (lastUndo.tipo == 'Tiempo Tecnico') {

                let timeout = lastUndo.data;
                let equipoAB = (timeout.id_equipo == this.equipoA ? 'A' : 'B');

                // re-add timeout to event list
                this.planilla.eventos.push(timeout);

                // update sheet
                let tiempos = this.getTiemposByTeamABSet(equipoAB, this.currentSet);
                if (equipoAB == 'A') this.planilla.planilla.sets[this.currentSet].equipoA.tiemposTanteador = tiempos;
                if (equipoAB == 'B') this.planilla.planilla.sets[this.currentSet].equipoB.tiemposTanteador = tiempos;
            }

            // sancion
            if (lastUndo.tipo == 'Sancion') {

                let sanction = lastUndo.data;

                // re-add sanction to event list
                this.planilla.eventos.push(sanction);
            }
            
            // report action event
            this.$eventHub.$emit('action');
            this.$eventHub.$emit('persist');

            // update dash scoreboard
            this.dashSendAction(this.DASH_ACTIONS.continue, {jugador: null});
        },
        
        dashSetMatchData: function(action, params) {

            let ret = {
                dashId: this.config.dashId,
                currentSet: this.currentSet+1,
                saque: this.currentPunto.servicio,
                inicioPartido: this.getSetInitialPoint(0).inicio,
                inicioSet: this.getSetInitialPoint(this.currentSet).inicio,
                equipoA: this.equipoA,
                equipoAObj: this.planilla.equipoA,
                ladoA: this.currentLadoA,
                tanteadorA: this.currentScoreA,
                cambiosA: this.getCambiosByTeamABSet('A', this.currentSet).length,
                tiemposA: this.getTiemposByTeamABSet('A', this.currentSet).length,
                rotacionA: (this.currentPunto && this.currentPunto.rotacionA ? this.currentPunto.rotacionA.join(',') : ''),
                equipoB: this.equipoB,
                equipoBObj: this.planilla.equipoB,
                ladoB: this.currentLadoB,
                tanteadorB: this.currentScoreB,
                cambiosB: this.getCambiosByTeamABSet('B', this.currentSet).length,
                tiemposB: this.getTiemposByTeamABSet('B', this.currentSet).length,
                rotacionB: (this.currentPunto && this.currentPunto.rotacionB ? this.currentPunto.rotacionB.join(',') : ''),
                set1A: Number(this.getTantosSet('A', 0)),
                set1B: Number(this.getTantosSet('B', 0)),
                set2A: Number(this.getTantosSet('A', 1)),
                set2B: Number(this.getTantosSet('B', 1)),
                set3A: Number(this.getTantosSet('A', 2)),
                set3B: Number(this.getTantosSet('B', 2)),
                set4A: Number(this.getTantosSet('A', 3)),
                set4B: Number(this.getTantosSet('B', 3)),
                set5A: Number(this.getTantosSet('A', 4)),
                set5B: Number(this.getTantosSet('B', 4)),
                setsA: this.getSetsAB('A'),
                setsB: this.getSetsAB('B'),
                division: this.planilla.division,
                rama: this.planilla.rama,
                id_torneo: this.planilla.id_torneo
            }

            if (this.dashReverseLado) {
                ret.ladoA = this.currentLadoB;
                ret.ladoB = this.currentLadoA;
            }    

            if (action == 'continue') {
                                
                ret.setPoint = this.isSetPoint;
                ret.matchPoint = this.isMatchPoint;

                if (params) {
                    ret.maximoAnotador = params.jugador ? this.getEstadisticasMaximoAnotador() == params.jugador.id : false;
                    ret.mejorSacador = params.jugador ? this.getEstadisticasMejorSacador() == params.jugador.id : false;
                    ret.mejorBloqueador = params.jugador ? this.getEstadisticasMejorBloqueador() == params.jugador.id : false;
                    ret.jugador = params.jugador;
                    ret.equipo = params.equipo;
                    ret.tipo = params.tipo;
                    ret.totalSet = params.totalSet;
                    ret.totalPartido = params.totalPartido;
                    ret.totalPuntos = params.jugador ? this.getEstadisticaPuntosByJugador(params.jugador.id) : 0;
                }
            }

            if (action == 'timeout') {
                ret.teamAB = params.teamAB;
            }

            if (action == 'presentation') {

                ret.playersA = [];
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 1));
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 2));
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 3));
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 4));
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 5));
                ret.playersA.push(this.getSetStarter(this.currentLadoA, 6));
                ret.liberosA = this.getLiberos(this.currentLadoA);                
                ret.substitutesA = this.getSubstitutes(this.currentLadoA, false);
                ret.tecnicosA = [];
                if (this.planilla.equipoA.entrenador) ret.tecnicosA.push(this.planilla.equipoA.entrenador);
                if (this.planilla.equipoA.asistente1) ret.tecnicosA.push(this.planilla.equipoA.asistente1);
                if (this.planilla.equipoA.asistente2) ret.tecnicosA.push(this.planilla.equipoA.asistente2);
                
                ret.playersB = [];
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 1));
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 2));
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 3));
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 4));
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 5));
                ret.playersB.push(this.getSetStarter(this.currentLadoB, 6));
                ret.liberosB = this.getLiberos(this.currentLadoB);
                ret.substitutesB = this.getSubstitutes(this.currentLadoB, false);
                ret.tecnicosB = [];
                if (this.planilla.equipoB.entrenador) ret.tecnicosB.push(this.planilla.equipoB.entrenador);
                if (this.planilla.equipoB.asistente1) ret.tecnicosB.push(this.planilla.equipoB.asistente1);
                if (this.planilla.equipoB.asistente2) ret.tecnicosB.push(this.planilla.equipoB.asistente2);
            }

            if (action == 'substitution') {
                ret.substitutions = params.substitutions;
            }

            if (action == 'sanction') {
                ret.sanction = params.sanction;
            }

            if (action == 'endSet') {
                ret.estadisticas = this.getEstadisticasByTeam(this.currentSet);
            }

            if (action == 'nextMatch') {
                let jugadoresA = this.planilla.equipoA && this.planilla.equipoA.jugadores ? this.planilla.equipoA.jugadores.filter(item => item.foto_transparente && item.foto_transparente != '') : [];
                let jugadoresB = this.planilla.equipoB && this.planilla.equipoB.jugadores ? this.planilla.equipoB.jugadores.filter(item => item.foto_transparente && item.foto_transparente != '') : [];
                ret.jugadorA = jugadoresA && jugadoresA.length ? jugadoresA[Math.floor(Math.random()*jugadoresA.length)] : {};
                ret.jugadorB = jugadoresB && jugadoresB.length ? jugadoresB[Math.floor(Math.random()*jugadoresB.length)] : {};
            }

            if (action == 'endMatch') {
                ret.estadisticas = this.getEstadisticasByTeam();
                ret.jugador = this.planilla.jugadorPartido ? this.getJugadorById(this.planilla.jugadorPartido) : {};
                ret.equipo = ret.jugador.equipo;                
            }

            if (action == 'mvp') {
                ret.jugador = this.planilla.jugadorPartido ? this.getJugadorById(this.planilla.jugadorPartido) : {};
                ret.equipo = ret.jugador.equipo;                
            }

            if (action == 'team') {
                ret.equipo = params.teamAB == 'A' ? this.equipoA : this.equipoB;
                ret.players = params.teamAB == 'A' ? this.planilla.equipoA.jugadores : this.planilla.equipoB.jugadores;
            }

            return ret;
        },
        
        dashSendAction: async function(action, params) {

            if (this.forceOffline) return;

            // add session info
            let data = this.dashSetMatchData(action, params);

            data.id = new Date().getTime();
            data.timestamp = new Date().getTime();
            data.action = action;
            data.cliente_logo = this.currentUser.cliente_logo;

            this.dashLastAction = action;

            try {

                await this.socket.emit("action", data);

            } catch (err) {
                this.dashOnline = false;
            }
        },

        sendNotification: async function(type, data) {
            try {
                await this.socket.emit(type, data);
            } catch (err) {
                console.log('Error sending notification', err);
            }
        },

        getEstadisticasByTeam(set) {

            if (!this.planilla.estadisticas) return [];

            let results = new Array();
            let totalEquipoA = 0;
            let totalEquipoB = 0;

            results.push({id: 'puntoSaque', equipoA: 0, equipoB: 0});
            results.push({id: 'puntoAtaque', equipoA: 0, equipoB: 0});
            results.push({id: 'puntoBloqueo', equipoA: 0, equipoB: 0});
            results.push({id: 'errorSaque', equipoA: 0, equipoB: 0});
            results.push({id: 'error', equipoA: 0, equipoB: 0});

            this.planilla.estadisticas.map(estadistica => {

                let result = results.find(result => result.id == estadistica.tipo);

                const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(estadistica.tipo) != -1);
                const esError = (['errorSaque', 'error'].indexOf(estadistica.tipo) != -1);

                if (set == undefined || estadistica.set == set) {

                    if ((estadistica.equipo == this.equipoA && esPunto) ||
                        (estadistica.equipo == this.equipoB && esError)) {
                        result['equipoA']++;
                        totalEquipoA++;
                    }

                    if ((estadistica.equipo == this.equipoB && esPunto) ||
                        (estadistica.equipo == this.equipoA && esError)) {
                        result['equipoB']++;
                        totalEquipoB++;
                    }
                }
            })

            results.push({id: 'total', key: 'Total', equipoA: totalEquipoA, equipoB: totalEquipoB});

            return results;
        },        

        isDashOnline: async function() {
            try {
                return this.socket.connected;
            } catch (err) {
                return false;
            }
        },

        registrarEstadisticaBasica: function(side, posicion, numero, rol, tipo, subtipo, jugador2) {

            let jugador = this.getJugadorByNumeroSide(numero, side);

            const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(tipo) != -1);
            const esError = (['errorSaque', 'error'].indexOf(tipo) != -1);
            const otherSide = side == 'I' ? 'D' : 'I';

            let estadistica = {
                jugador: jugador.id,
                equipo: this.getTeamIdBySide(side),
                posicion: (rol.includes('libero') ? 'libero' : posicion),
                set: this.currentSet,
                punto: this.currentPunto.id_punto,
                tipo: tipo,
                subtipo: subtipo,
                jugador2: jugador2,
                valor: null
            }

            if (!this.planilla.estadisticas) this.planilla.estadisticas = [];
            this.planilla.estadisticas.push(estadistica);

            if (esPunto) this.point(side);
            if (esError) this.point(otherSide);

            this.$eventHub.$emit('estadisticaUpdated');
        },

        getEstadisticaPuntosByJugador: function(jugador, set) {
            let ret = 0;
            this.planilla.estadisticas.map(estadistica => {
                const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(estadistica.tipo) != -1);
                if (set == estadistica.set || set == undefined) {
                    if (estadistica.jugador == jugador && esPunto) ret++;
                }
            })
            return ret;

        },

        getEstadisticaTotalByJugador: function(jugador, tipo, set) {
            let ret = 0;
            this.planilla.estadisticas.map(estadistica => {
                if (set == estadistica.set || set == undefined) {
                    if (estadistica.jugador == jugador && estadistica.tipo == tipo) ret++;
                }
            })
            return ret;
        },

        getEstadisticasMaximoAnotador: function() {
            let jugadores = new Array();
            this.planilla.estadisticas.map(estadistica => {
                const esPunto = (['puntoSaque', 'puntoAtaque', 'puntoBloqueo'].indexOf(estadistica.tipo) != -1);
                if (!jugadores[estadistica.jugador]) jugadores[estadistica.jugador] = 0;
                if (esPunto) jugadores[estadistica.jugador]++;
            })
            let max = utils.indexOfMax(jugadores);
            return max;
        },

        getEstadisticasJugadoresDestacados: function() {

            let maximoAnotador = null;
            let mejorAtacante = null;
            let mejorSacador = null;
            let mejorBloqueador = null;
            let jugadores = [];

            this.planilla.estadisticas.map(estadistica => {
                
                if (!jugadores[estadistica.jugador]) {
                    jugadores[estadistica.jugador] = {
                        puntos: 0,
                        ataques: 0,
                        saques: 0,
                        bloqueos: 0,
                        lastPunto: 0,
                        lastAtaque: 0,
                        lastSaque: 0,
                        lastBloqueo: 0,
                        id: estadistica.jugador
                    }
                }

                jugadores[estadistica.jugador].lastPunto = Number(`${estadistica.set}${estadistica.punto}`);

                if (estadistica.tipo == 'puntoAtaque') {
                    jugadores[estadistica.jugador].puntos++;
                    jugadores[estadistica.jugador].ataques++;
                    jugadores[estadistica.jugador].lastAtaque = Number(`${estadistica.set}${estadistica.punto}`);
                }

                if (estadistica.tipo == 'puntoSaque') {
                    jugadores[estadistica.jugador].puntos++;
                    jugadores[estadistica.jugador].saques++;
                    jugadores[estadistica.jugador].lastSaque = Number(`${estadistica.set}${estadistica.punto}`);
                }

                if (estadistica.tipo == 'puntoBloqueo') {
                    jugadores[estadistica.jugador].puntos++;
                    jugadores[estadistica.jugador].bloqueos++;
                    jugadores[estadistica.jugador].lastBloqueo = Number(`${estadistica.set}${estadistica.punto}`);
                }
            })

            jugadores.map(jugador => {
                if ((!maximoAnotador && jugador.puntos) || 
                    (maximoAnotador && jugador.puntos > maximoAnotador.puntos) || 
                    (maximoAnotador && jugador.puntos == maximoAnotador.puntos && jugador.lastPunto < maximoAnotador.lastPunto)) {
                    maximoAnotador = {
                        id: jugador.id,
                        puntos: jugador.puntos,
                        lastPunto: jugador.lastPunto
                    }
                }
                if ((!mejorAtacante && jugador.ataques) || 
                    (mejorAtacante && jugador.ataques > mejorAtacante.ataques) || 
                    (mejorAtacante && jugador.ataques == mejorAtacante.ataques && jugador.lastAtaque < mejorAtacante.lastAtaque)) {
                    mejorAtacante = {
                        id: jugador.id,
                        ataques: jugador.ataques,
                        lastAtaque: jugador.lastAtaque
                    }
                }
                if ((!mejorSacador && jugador.saques) || 
                    (mejorSacador && jugador.saques > mejorSacador.saques) || 
                    (mejorSacador && jugador.saques == mejorSacador.saques && jugador.lastSaque < mejorSacador.lastSaque)) {
                    mejorSacador = {
                        id: jugador.id,
                        saques: jugador.saques,
                        lastSaque: jugador.lastSaque
                    }
                }
                if ((!mejorBloqueador && jugador.bloqueos) || 
                    (mejorBloqueador && jugador.bloqueos > mejorBloqueador.bloqueos) || 
                    (mejorBloqueador && jugador.bloqueos == mejorBloqueador.bloqueos && jugador.lastBloqueo < mejorBloqueador.lastBloqueo)) {
                    mejorBloqueador = {
                        id: jugador.id,
                        bloqueos: jugador.bloqueos,
                        lastBloqueo: jugador.lastBloqueo
                    }
                }
            })

            return {
                maximoAnotador: maximoAnotador,
                mejorAtacante: mejorAtacante,
                mejorSacador: mejorSacador,
                mejorBloqueador: mejorBloqueador
            }
        },

        getEstadisticasMejorSacador: function() {
            let jugadores = new Array();
            this.planilla.estadisticas.map(estadistica => {
                if (!jugadores[estadistica.jugador]) jugadores[estadistica.jugador] = 0;
                if (estadistica.tipo == 'puntoSaque') jugadores[estadistica.jugador]++;
            })
            let max = utils.indexOfMax(jugadores);
            return max;
        },

        getEstadisticasMejorBloqueador: function() {
            let jugadores = new Array();
            this.planilla.estadisticas.map(estadistica => {
                if (!jugadores[estadistica.jugador]) jugadores[estadistica.jugador] = 0;
                if (estadistica.tipo == 'puntoBloqueo') jugadores[estadistica.jugador]++;
            })
            let max = utils.indexOfMax(jugadores);
            return max;
        },

        getDashWSURL: function() {
            let protocol = (this.config.dashMode == 'wss' && !this.config.dashHost.includes("localhost")) ? 'https' : 'http';
            let url = `${protocol}://${this.config.dashHost}`;
            return url;
        },

        onSocketDataReceived(data) {

            if (data.action == 'refreshImages') {
                if (data && data.jugador && data.jugador.id) {
                    
                    // update player photos on current planilla
                    let idxa = this.planilla.equipoA.jugadores.findIndex(item => item.id == data.jugador.id);
                    if (idxa >= 0) this.planilla.equipoA.jugadores[idxa].foto_transparente = data.jugador.foto_transparente;                    
                    let idxb = this.planilla.equipoB.jugadores.findIndex(item => item.id == data.jugador.id);
                    if (idxb >= 0) this.planilla.equipoB.jugadores[idxb].foto_transparente = data.jugador.foto_transparente;
                    this.$eventHub.$emit('action');
                }
            }
        },

        getProgresion() {

            let progresion = new Object();
            let jugadores = this.planilla.equipoA.jugadores.concat(this.planilla.equipoB.jugadores);
        
            this.planilla.puntos.map((punto) => {

              if (punto.tanteadorA == null && punto.tanteadorB == null) return;
        
              if (!progresion[`set${punto.id_set+1}`]) progresion[`set${punto.id_set+1}`] = new Array();
        
              // search eventos
              this.planilla.eventos
                .filter((item) => (item.id_set == punto.id_set && item.id_punto == punto.id_punto))
                .map((evento) => {
        
                  let jugador = jugadores.find((jug) => jug.id == evento.id_persona);
                  let jugadorOut = jugadores.find((jug) => jug.id == evento.id_persona_out);
                  let apellido = jugador && jugador.apellido ? jugador.apellido.trim().toUpperCase() : '';
                  let apellidoOut = jugadorOut && jugadorOut.apellido ? jugadorOut.apellido.trim().toUpperCase() : '';
        
                  let ev = {
                    tipo: evento.tipo
                  }
        
                  if (evento.tipo == 'tiempo') {
                    ev.titulo = 'TIEMPO TECNICO';
                    ev.descripcion = '';
                  }
                  if (evento.tipo == 'cambio') {
                    ev.titulo = 'SUSTITUCIÓN';
                    ev.descripcion = `Entra #${evento.numero} ${apellido} | Sale #${evento.numero_out} ${apellidoOut}`;
                  }
                  if (evento.tipo == 'sanction:warning') {
                    ev.titulo = 'ADVERTENCIA';
                    ev.descripcion = `#${evento.numero} ${apellido}`;
                  }
                  if (evento.tipo == 'sanction:green') {
                    ev.titulo = 'TARJETA VERDE';
                    ev.descripcion = `#${evento.numero} ${apellido}`;
                  }
                  if (evento.tipo == 'sanction:delay') {
                    ev.titulo = 'DEMORA';
                    ev.descripcion = ``;
                  }
                  if (evento.tipo == 'sanction:delayPenalty') {
                    ev.titulo = 'AMONESTACIÓN POR DEMORA';
                    ev.descripcion = ``;
                  }
                  if (evento.tipo == 'sanction:penalty') {
                    ev.titulo = 'AMONESTACIÓN';
                    ev.descripcion = `#${evento.numero} ${apellido}`;
                  }
                  if (evento.tipo == 'sanction:expulsion') {
                    ev.titulo = 'EXPULSIÓN';
                    ev.descripcion = `#${evento.numero} ${apellido}`;
                  }
                  if (evento.tipo == 'sanction:disqualification') {
                    ev.titulo = 'DESCALIFICACIÓN';
                    ev.descripcion = `#${evento.numero} ${apellido}`;
                  }
        
                  progresion[`set${punto.id_set+1}`].push({
                    tanteadorA: punto.tanteadorA,
                    tanteadorB: punto.tanteadorB,
                    eventoA: evento.id_equipo == this.equipoA ? ev : null,
                    eventoB: evento.id_equipo == this.equipoB ? ev : null
                  })
              })
        
              let estadistica = this.planilla.estadisticas.find((item) => (item.set == punto.id_set && item.punto == punto.id_punto));
              let estadisticaEv = new Object();
              
              if (estadistica) {
        
                estadisticaEv.tipo = estadistica.tipo;
        
                if (estadisticaEv.tipo == 'puntoAtaque') estadisticaEv.titulo = 'ATAQUE';
                if (estadisticaEv.tipo == 'puntoBloqueo') estadisticaEv.titulo = 'BLOQUEO';
                if (estadisticaEv.tipo == 'puntoSaque') estadisticaEv.titulo = 'ACE';
                if (estadisticaEv.tipo == 'error') estadisticaEv.titulo = 'ERROR NO FORZADO';
                if (estadisticaEv.tipo == 'errorSaque') estadisticaEv.titulo = 'ERROR SAQUE';
        
                let jugadorEst = jugadores.find((item) => item.id == estadistica.jugador);
                let apellidoEst = jugadorEst && jugadorEst.apellido ? jugadorEst.apellido.toUpperCase() : '';
        
                estadisticaEv.descripcion = `#${jugadorEst.numero} ${apellidoEst}`;
        
                progresion[`set${punto.id_set+1}`].push({
                  tanteadorA: punto.tanteadorA,
                  tanteadorB: punto.tanteadorB,
                  eventoA: estadistica.equipo == this.equipoA ? estadisticaEv : null,
                  eventoB: estadistica.equipo == this.equipoB ? estadisticaEv : null
                })
              } else {
        
                progresion[`set${punto.id_set+1}`].push({
                  tanteadorA: punto.tanteadorA,
                  tanteadorB: punto.tanteadorB,
                  eventoA: null,
                  eventoB: null
                })
              }
            })
        
            return progresion;
        },

        async checkDeviceVerification() {

            let url = encodeURI(this.$root.config.apiURL + '/api/usuario/deviceVerification/' + this.$root.config.deviceId);

            try {

                const res = await this.axios.get(url);

                this.config.deviceVerification = res.data;

            } catch (err) {

                console.log(err);
            }

        },

        async downloadEstadisticas() {

            let idCliente = this.currentUser.id_cliente ? this.currentUser.id_cliente : 0;
            let url = encodeURI(`${this.$root.config.apiURL}/api/ruler/downloadClientData/${idCliente}`);
            try {
                this.axios.get(url).then(response => {
                    this.$store.dispatch('estadisticas/setAndPersistLS', response.data.data.estadisticas);
                })
            } catch (err) {
                this.$store.dispatch('estadisticas/setAndPersistLS', this.configEstadisticas);
            }
        },

        downloadJSON(data, filename='') {
            const jsonString = JSON.stringify(data, null, 2);
            const blob = new Blob([jsonString], { type: 'application/json' });
            const url = URL.createObjectURL(blob);

            if (!filename) {
                filename = `${new Date().toLocaleDateString('sv-SE')}-${data.equipoA.id}-${data.equipoB.id}.json`;
            }
          
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();
          
            URL.revokeObjectURL(url);
        },

        checkForTranslation(elementId, expected) {

            const el = document.getElementById(elementId);

            if (!el) return;
        
            const actual = el.textContent.trim();
        
            if (actual && actual !== expected) {
                this.$bvModal.msgBoxOk(i18n.t('translation-check-message'), {
                    title: i18n.t('translation-check-title'),
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'warning',
                    okTitle: 'Ok',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async () => {                
                    this.refreshVersion();
                })
            }
        }
    },

    store,
    router,
    render: h => h(App)
}).$mount('#app')